import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from "react-query";

import { useApi } from "./context";

import {
  LeadIdentityView,
  FeedbackSummaryResponseView,
  CampaignFeedbackRankingResponseView,
  CampaignFeedbackRankingQuery,
  FeedbackDistributionResponseView,
  FeedbackTimeSeriesResponseView,
  SenderDetailsUpdateView,
  SenderDetailsView,
  SenderDetailsFilterView,
  PageSenderDetailsView,
  Pageable,
  Sort,
  ExportInvoicesView,
  IntegrationFilterView,
  IntegrationItemView,
  IntegrationsView,
  IdentityLogoView,
  IdentityView,
  LinkView,
  SocialLinkView,
  CampaignUpdateRequestView,
  CampaignResponseView,
  CampaignCloneUndeliveredResponseView,
  CampaignTestEmailsView,
  CampaignRemainedTestEmailsView,
  CampaignStartView,
  SenderDetailsIdentityView,
  SenderAllocationsGetResponseView,
  SegmentIdentitiesView,
  SegmentIdentityView,
  EnabledView,
  ActivityIdentitiesView,
  ActivityIdentityView,
  ActivityDetailsView,
  TemplateTagView,
  IdView,
  IdsView,
  CampaignFilterView,
  CampaignInfoView,
  PageCampaignInfoView,
  ActivityFilterView,
  PageActivityIdentityView,
  EmailActivityTemplateFilterView,
  EmailActivityTemplateIdentityView,
  PageEmailActivityTemplateIdentityView,
  AccountView,
  AccountIntegrationExecutionView,
  ConfigurableNotificationUpdateView,
  ConfigurableNotificationCategoryUpdateView,
  SubscriptionCostCalculateParametersView,
  SubscriptionCostView,
  TaxRateView,
  AttachBillingInformationView,
  TicketCreateRequestDto,
  LeadView,
  LicenseView,
  LicenseCreatedView,
  SenderDetailsCreateView,
  SenderDetailsEmailConfirmationView,
  AttachPaymentMethodView,
  AddressResponse,
  BillingDetailsResponse,
  CardResponse,
  LastSetupError,
  PaymentMethodResponse,
  PaymentMethodView,
  CampaignCreateRequestView,
  CampaignCreateByTemplateRequestView,
  CampaignStatisticsTotalRequestView,
  CampaignStatisticsTotalResponseView,
  CampaignStatisticsGroupedRequestView,
  CampaignStatisticsGroupedResponseView,
  CampaignTimeGroupStatisticsView,
  CampaignCloneRequestView,
  AccountCreateView,
  CreateSubAccountView,
  SubAccountView,
  AccountIntegrationView,
  AssignSubscriptionView,
  AssignSubscriptionWithPaymentMethodView,
  AssignSubscriptionWithBillingInfoView,
  TemplateTagsView,
  SubscriptionFeatureView,
  SubscriptionView,
  SubscriptionsView,
  TierView,
  SubscriptionFeatureAvailabilityView,
  SubscriptionFeaturesAvailabilityView,
  SubscriptionFeaturesCategoriesAvailabilityView,
  SenderDetailsesView,
  PaymentMethodsView,
  InvoiceView,
  InvoicesView,
  SocialLinksView,
  ColorsView,
  FontView,
  IdentityProfiledView,
  LogoView,
  EditorTokenView,
  ActivityDetailsListView,
  ActivityEmailFooterView,
  ActivityTemplateAttributeView,
  ActivityTemplateAttributesView,
  CampaignIdentitiesView,
  CampaignIdentityView,
  EmailActivityTemplateDetailsView,
  AccountIntegrationItemView,
  AccountPlatformUsageView,
  AccountTemplatesPlatformUsageView,
  AccountIntegrationsPlatformUsageView,
  AccountCampaignsPlatformUsageView,
  AccountAudiencesPlatformUsageView,
  ConfigurableNotificationCategoryView,
  ConfigurableNotificationSettingView,
  ConfigurableNotificationSettingsView,
  AccountIssueView,
  AccountIssuesView,
  AccountSubscriptionRecommendationView,
  AccountSubscriptionView,
  UsageView,
  AccountLeadSubscriptionView,
  SubscriptionFeaturesView,
  SubscriptionFeaturesCategoriesView,
  SubscriptionFeaturesCategoryView,
  AccountSubscriptionBillingInfoView,
  BillingInfoView,
  ContactInfoView,
  AccountIntegrationsView,
  AccountIntegrationsSummaryView,
  SenderDetailsDeleteView,
  CampaignMultipleDeleteView,
  ActivityMultipleDeleteView,
  BaseCondition,
  CombinedCondition,
  Condition,
  ConditionValueObject,
  SegmentUpdateView,
  SegmentIdentityView1,
  CustomersUpdateView,
  SegmentTypeStatisticRequestView,
  SegmentTypeStatisticResponseView,
  SegmentIdentitiesView1,
  SegmentFilterView,
  SegmentPageSegmentView,
  SegmentView,
  CustomSegmentSummaryRequestView,
  AudienceCriteriaView,
  AudienceView,
  CustomSegmentSummaryResponseView,
  SegmentCheckExistsFilterView,
  CustomerView,
  CustomerStatusUpdateView,
  CustomerFilterView,
  CustomerInfoView,
  PageCustomerInfoView,
  CustomerCompositeFilterView,
  CustomerEventFilterView,
  CustomerExcludeFilterView,
  CustomerPropertyFilterView,
  CustomerSegmentFilterView,
  FilterViewWrapperCustomerEventFilterView,
  FilterViewWrapperCustomerPropertyFilterView,
  FilterViewWrapperCustomerSegmentFilterView,
  CustomerActionPlatformFindFilterView,
  CustomerActionPlatformInfoView,
  CustomerActionGeolocationFindFilterView,
  CustomerActionGeolocationInfoView,
  CustomerActionDomainFindFilterView,
  CustomerActionDomainInfoView,
  IspBreakdownItemView,
  CustomerSegmentInfoView,
  PageCustomerSegmentInfoView,
  CustomerBatchView,
  UploadSegmentCreateView,
  SegmentTotalStatisticsResponseView,
  SegmentTotalCustomersStatisticsRequestView,
  SegmentCustomersStatisticView,
  SegmentTotalCustomersStatisticsResponseView,
  IntegrationSegmentStatisticsGrowthRequestView,
  IntegrationSegmentStatisticGrowthView,
  IntegrationSegmentStatisticsGrowthResponseView,
  SegmentImportView,
  CustomSegmentCreateView,
  SegmentCloneRequestView,
  CustomerStatisticsTotalRequestView,
  CustomerStatisticsTotalResponseView,
  CustomerStatisticsGroupedRequestView,
  CustomerStatisticsGroupedResponseView,
  CustomerTimeGroupStatisticsView,
  CustomerEventStatisticsGroupedRequestView,
  CustomerEventStatisticsGroupedResponseView,
  CustomerEventTimeGroupStatisticsView,
  CustomerEventStatisticsTotalRequestView,
  CustomerEventStatisticsTotalResponseView,
  CustomerEventMostOpenStatisticsFilterView,
  CustomerEventMostOpenStatisticsResponseView,
  CustomerGroupedOpenEventView,
  CustomerEventMostClickStatisticsFilterView,
  CustomerEventMostClickStatisticsResponseView,
  CustomerGroupedClickEventView,
  SegmentDetailsView,
  Attribute,
  AttributeType,
  SegmentAttributesView,
  SegmentsView,
  TagsView,
  CustomerTotalView,
  SegmentMultipleDeleteView,
  SegmentUnassignCustomersView,
  SubjectLineFilterView,
  PageSubjectLineView,
  SubjectLineView,
  SubjectGenerateRequestView,
  SubjectGenerateResponseView,
  ToneView,
  TonesView,
  MergeTagView,
  MergeTagsView,
  SubjectLineFeatureInfoView,
  FormUpdateRequestView,
  FormUpdateResponseView,
  FormFilterView,
  FormInfoView,
  PageFormInfoView,
  CategoryElementView,
  ControlElementView,
  FormAppearanceView,
  FormConfigView,
  FormContentView,
  FormPayloadView,
  FormTriggerDetailsView,
  FormTriggerEventView,
  GroupElementView,
  JsonSchemaView,
  LabelElementView,
  LayoutElementView,
  UiSchemaElementView,
  FormAllowedDomainsView,
  FormCheckAssignedAudiencesRequestView,
  FormCheckAssignedAudiencesResponseView,
  FormTemplateFilterView,
  FormTemplateInfoView,
  PageFormTemplateInfoView,
  FormView,
  FormIdentityView,
  FormCloneRequestView,
  FormCloneResponseView,
  FormWithTemplateView,
  FormPlatformUsageView,
  FormDetailsView,
  FormDeleteRequestView,
  AccountAutomationView,
  AutomationTemplateView,
  AutomationsView,
  CampaignContentSourceRequestView,
  DomainEngagementFilterView,
  PageDomainEngagementInfoView,
  DomainDeliverabilityFilterView,
  PageDomainDeliverabilityInfoView,
  CampaignChildLastSentResponseView,
  AudienceMergeView,
  SegmentMoveRequestView,
  SegmentMoveResultView,
  SuppressionFilterView,
  SuppressionPageSuppressionView,
  SuppressionView,
  PageSuppressionInfoView,
  SuppressionDetailsFilterView,
  CreateSuppressionRequestView,
  CreateSuppressionResponseView,
  SuppressionStatisticsTotalRequestView,
  SuppressionStatisticsTotalResponseView,
  SuppressionCheckExistsFilterView,
  SuppressionUpdateView,
  suppressionDetailsItem,
  SuppressionMultipleDeleteView,
  SuppressionSearchResponseView,
  PredefinedSegmentsCountsResponseView,
  SuppressionIdentitiesView,
  AudienceIdentitiesView,
  ExcludedWorkflowsView,
  ExcludedWorkflowsResponseView,
  customFontsResponseView,
  customFontsRequestView,
  CustomFont,
  SenderDetailsAuthenticationView,
  EntriTokenView,
  ResolveIssueView,
  SegmentUniqueCountRequestView,
  SegmentUniqueCountResponseView,
  DomainLevelMetricsResponse,
  DomainLevelMetricsFilter,
  RelayStatsFilter,
  RelayStatsResponse,
  UserDetailsFilterView,
  PageUserDetailsView,
  MfaEmailOtpRequestView,
  MfaPreferenceRequestView,
  UserDetailsView,
  AccountMemberCreateView,
  AccountMemberUpdateView,
  AccountMemberPermissionsView,
  PageAccountMemberAuditView,
  SetupMemberPassword,
  AIInsightsFilter,
  EmailContentCheckResponse,
  EmailUnvettedCheckResponse,
  AITrafficShapingPageView,
  AITrafficCreateView,
  AiTrafficShappingIdentitiesView,
  PageCampaignInfoViewBasic,
  WorkflowFilterView,
  PageWorkflowInfoView,
  ExportSegmentCreateView,
  SegmentDataExistCheckView,
  AITrafficControlLogsFilter,
  AITrafficControlLogsResponse,
  AITrafficControlStatsFilter,
  AITrafficControlStatsResponse,
  AITrafficControlSegmentsFilter,
  AITrafficControlSegmentsResponse,
  AITrafficControlEngagerStatsResponse,
  AITrafficControlEngagerStatsFilter,
  AITrafficControlSegmentProgressRequest,
  AITrafficControlSegmentProgressResponse,
  SubAccountUsageResponseView,
  SegmentCleanupHistoryRequestView,
  SegmentCleanupHistoryResponseView,
  SegmentCleanupHistoriesResponseView,
  CleanedFileUrlView,
  SegmentCleanupFileDownloadRequestView,
  ProductCalculateCostRequestView,
  ProductCalculateCostResponseView,
  ProductPurchaseRequestView,
  ProductPurchaseResponseView,
  ProductTierView,
  DeliverabilitySettingsView,
  GlobalActiveEngagerSegmentView,
  GlobalActiveEngagerSettingsView,
  PreSignedUrlGenerateRequestView,
  PreSignedUrlGenerateResponseView,
  CreditBalanceView,
  CreditPurchaseRequestView,
  CreditPurchaseResponseView,
  CreditsUseRequestView,
  CreditsUseResponseView,
  CreditsCalculateRequestView,
  CreditsCalculateResponseView,
  ProductUsageHistoryView,
  ProductPurchaseHistoryView,
  ProductView,
  RetentionIntegrationView,
  AutoTopUpConfigView,
  AutoTopUpConfigUpdateView,
  FormImageUploadResponseView,
  SubscriberEngagementRequestView,
  SubscriberEngagementItemView,
  IspEngagementRequestView,
  IspEngagementItemView,
  CustomAttributeDefinitionView,
  CustomAttributesResponseView,
  CustomAttributeMergeTagsView,
  CreateCustomAttributeRequestView,
  DeleteCustomAttributeRequestView,
  WorkflowTemplatePreviewFilterView,
  WorkflowTemplatePreviewResponseView,
  EngagementScoringAnalyticsRequest,
  EngagementScoringAnalyticsResponse,
  RelayAccount,
  RelayManagementPageResponse,
  ApiKeyView,
  ApiKeyCreateRequestView,
  ApiKeyUpdateRequestView,
  AbTestView,
  AbTestCreateRequestView,
  AbTestUpdateRequestView,
  AbTestVariationsRequestView,
  PageAbTestView,
  UploadFileView,
} from "./generated";
import { DnsRecord } from "entrijs";

export interface ErrorEntity {
  errorCode: string;
  errorMessage: string;
}

export interface Error {
  message?: string;
  response?: {
    status?: number;
    data?: {
      message?: string;
      messageDetails?: string;
      errorCodes?: ErrorEntity[];
    };
  };
}

export function usePutSubscriptionLeadContextEmailQuery(
  data: LeadIdentityView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", "/subscription/lead/context-email", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putSubscriptionLeadContextEmail(data);
      return result.data;
    },
    options
  );
}

export function useGetSenderDetailsByIdQuery(
  id: string,

  options?: UseQueryOptions<SenderDetailsView, Error>
): UseQueryResult<SenderDetailsView, Error> {
  const api = useApi();
  const key = ["GET", `/sender-details/${id}`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.getSenderDetailsById(id);
      return result.data;
    },
    options
  );
}

export function usePutSenderDetailsByIdQuery(
  id: string,

  data: SenderDetailsUpdateView,

  options?: UseQueryOptions<SenderDetailsView, Error>
): UseQueryResult<SenderDetailsView, Error> {
  const api = useApi();
  const key = ["PUT", `/sender-details/${id}`, id, data];
  return useQuery(
    key,
    async () => {
      const result = await api.putSenderDetailsById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutSenderDetailsFindFilterQuery(
  data: SenderDetailsFilterView,

  query: { page?: number; size?: number; sort?: string[] },

  options?: UseQueryOptions<PageSenderDetailsView, Error>
): UseQueryResult<PageSenderDetailsView, Error> {
  const api = useApi();
  const key = ["PUT", "/sender-details/find/filter", data, query];
  return useQuery(
    key,
    async () => {
      const result = await api.putSenderDetailsFindFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePutUserDetailsFindFilterQuery(
  data: UserDetailsFilterView,
  query: { page?: number; size?: number; sort?: string[] },
  options?: UseQueryOptions<PageUserDetailsView, Error>
): UseQueryResult<PageUserDetailsView, Error> {
  const api = useApi();
  const key = ["PUT", "/account-member/find/filter", data, query];
  return useQuery(
    key,
    async () => {
      const result = await api.putUserDetailsFindFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePutPaymentAccountPaymentMethodDefaultByIdQuery(
  id: string,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", `/payment-account/payment-method/${id}/default`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.putPaymentAccountPaymentMethodDefaultById(id);
      return result.data;
    },
    options
  );
}

export function usePutPaymentAccountInvoicePayByInvoiceIdQuery(
  invoiceId: string,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", `/payment-account/invoice/${invoiceId}/pay`, invoiceId];
  return useQuery(
    key,
    async () => {
      const result = await api.putPaymentAccountInvoicePayByInvoiceId(
        invoiceId
      );
      return result.data;
    },
    options
  );
}

export function usePutPaymentAccountInvoiceExportQuery(
  data: ExportInvoicesView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", "/payment-account/invoice/export", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putPaymentAccountInvoiceExport(data);
      return result.data;
    },
    options
  );
}

export function usePutIntegrationFindFilterQuery(
  data: IntegrationFilterView,

  options?: UseQueryOptions<IntegrationsView, Error>
): UseQueryResult<IntegrationsView, Error> {
  const api = useApi();
  const key = ["PUT", "/integration/find/filter", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putIntegrationFindFilter(data);
      return result.data;
    },
    options
  );
}

export function useGetIdentityLogoByIdQuery(
  id: string,

  options?: UseQueryOptions<IdentityLogoView, Error>
): UseQueryResult<IdentityLogoView, Error> {
  const api = useApi();
  const key = ["GET", `/identity/${id}/logo`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.getIdentityLogoById(id);
      return result.data;
    },
    options
  );
}

export function usePutIdentityLogoByIdQuery(
  id: string,

  data: { logoFile?: File },

  options?: UseQueryOptions<IdentityLogoView, Error>
): UseQueryResult<IdentityLogoView, Error> {
  const api = useApi();
  const key = ["PUT", `/identity/${id}/logo`, id, data];
  return useQuery(
    key,
    async () => {
      const result = await api.putIdentityLogoById(id, data);
      return result.data;
    },
    options
  );
}

export function useGetIdentityQuery(
  options?: UseQueryOptions<IdentityView, Error>
): UseQueryResult<IdentityView, Error> {
  const api = useApi();
  const key = ["GET", "/identity"];
  return useQuery(
    key,
    async () => {
      const result = await api.getIdentity();
      return result.data;
    },
    options
  );
}

export function usePutIdentityQuery(
  data: { logoFile?: File; identity: IdentityView },

  options?: UseQueryOptions<IdentityView, Error>
): UseQueryResult<IdentityView, Error> {
  const api = useApi();
  const key = ["PUT", "/identity", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putIdentity(data);
      return result.data;
    },
    options
  );
}

export function usePostIdentityQuery(
  data: { logoFile?: File; identity: IdentityView },

  options?: UseQueryOptions<IdentityView, Error>
): UseQueryResult<IdentityView, Error> {
  const api = useApi();
  const key = ["POST", "/identity", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postIdentity(data);
      return result.data;
    },
    options
  );
}

export function useGetCampaignByIdQuery(
  id: string,

  options?: UseQueryOptions<CampaignResponseView, Error>
): UseQueryResult<CampaignResponseView, Error> {
  const api = useApi();
  const key = ["GET", `/campaign/${id}`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.getCampaignById(id);
      return result.data;
    },
    options
  );
}

export function usePutDomainLevelMetricsQuery(
  data: DomainLevelMetricsFilter,
  options?: UseQueryOptions<DomainLevelMetricsResponse, Error>
): UseQueryResult<DomainLevelMetricsResponse, Error> {
  const api = useApi();
  const key = ["PUT", "/analytics/domain-level-metrics", data];

  return useQuery(
    key,
    async () => {
      const result = await api.putDomainLevelMetrics(data);
      return result.data;
    },
    options
  );
}

export function usePutDomainLevelMetricsAiInsightsQuery(
  data: AIInsightsFilter,
  options?: UseQueryOptions<{ insights: string }, Error>
): UseQueryResult<{ insights: string }, Error> {
  const api = useApi();
  const key = ["PUT", "/analytics/domain-level-metrics/ai-insights", data];

  return useQuery(
    key,
    async () => {
      const result = await api.putDomainLevelMetricsAiInsights(data);
      return result.data;
    },
    options
  );
}

export function useGetPredefinedSegmentCountsByIdQuery(
  id: string,

  options?: UseQueryOptions<PredefinedSegmentsCountsResponseView, Error>
): UseQueryResult<PredefinedSegmentsCountsResponseView, Error> {
  const api = useApi();
  const key = ["GET", `/pre-defined-segment/${id}`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.getPredefinedSegmentCounts(id);
      return result.data;
    },
    options
  );
}

export function useGetCampaignLastChildSentByIdQuery(
  id: string,

  options?: UseQueryOptions<CampaignChildLastSentResponseView, Error>
): UseQueryResult<CampaignChildLastSentResponseView, Error> {
  const api = useApi();
  const key = ["GET", `/campaign/${id}/recurring/child/latest`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.getCampaignLastChildSentById(id);
      return result.data;
    },
    options
  );
}

export function usePutCampaignByIdQuery(
  id: string,

  data: CampaignUpdateRequestView,

  options?: UseQueryOptions<CampaignResponseView, Error>
): UseQueryResult<CampaignResponseView, Error> {
  const api = useApi();
  const key = ["PUT", `/campaign/${id}/details`, id, data];
  return useQuery(
    key,
    async () => {
      const result = await api.putCampaignById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutCampaignUnscheduleByIdQuery(
  id: string,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", `/campaign/${id}/unschedule`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.putCampaignUnscheduleById(id);
      return result.data;
    },
    options
  );
}

export function usePutCampaignTestEmailsByIdQuery(
  id: string,

  data: CampaignTestEmailsView,

  options?: UseQueryOptions<CampaignRemainedTestEmailsView, Error>
): UseQueryResult<CampaignRemainedTestEmailsView, Error> {
  const api = useApi();
  const key = ["PUT", `/campaign/${id}/test-emails`, id, data];
  return useQuery(
    key,
    async () => {
      const result = await api.putCampaignTestEmailsById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutCampaignTemplateByIdQuery(
  id: string,

  options?: UseQueryOptions<CampaignResponseView, Error>
): UseQueryResult<CampaignResponseView, Error> {
  const api = useApi();
  const key = ["PUT", `/campaign/${id}/template`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.putCampaignTemplateById(id);
      return result.data;
    },
    options
  );
}

export function usePutCampaignStartByIdQuery(
  id: string,

  data: CampaignStartView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", `/campaign/${id}/start`, id, data];
  return useQuery(
    key,
    async () => {
      const result = await api.putCampaignStartById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutCampaignSenderDetailsByIdQuery(
  id: string,

  data: SenderDetailsIdentityView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", `/campaign/${id}/sender-details`, id, data];
  return useQuery(
    key,
    async () => {
      const result = await api.putCampaignSenderDetailsById(id, data);
      return result.data;
    },
    options
  );
}

export function useGetCampaignSenderAllocationsByIdQuery(
  id: string,

  options?: UseQueryOptions<SenderAllocationsGetResponseView, Error>
): UseQueryResult<SenderAllocationsGetResponseView, Error> {
  const api = useApi();
  const key = ["GET", `/campaign/${id}/sender-allocations`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.getCampaignSenderAllocationsById(id);
      return result.data;
    },
    options
  );
}

export function useGetCampaignSegmentsByIdQuery(
  id: string,

  options?: UseQueryOptions<SegmentIdentitiesView, Error>
): UseQueryResult<SegmentIdentitiesView, Error> {
  const api = useApi();
  const key = ["GET", `/campaign/${id}/audiences`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.getCampaignSegmentsById(id);
      return {
        segments: result?.data?.audiences?.map((aud: any) => {
          return {
            segmentType: aud?.audienceType,
            ...aud,
          };
        }) as SegmentIdentityView[],
      };
    },
    options
  );
}

export function useGetCampaignSuppressionsByIdQuery(
  id: string,
  options?: UseQueryOptions<SuppressionIdentitiesView, Error>
): UseQueryResult<SuppressionIdentitiesView, Error> {
  const api = useApi();
  const key = ["GET", `/campaign/${id}/suppressions`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.getCampaignSuppressionsById(id);
      return result.data;
    },
    options
  );
}

export function useGetCampaignExcludedAudiencesByIdQuery(
  id: string,
  options?: UseQueryOptions<SegmentIdentitiesView, Error>
): UseQueryResult<SegmentIdentitiesView, Error> {
  const api = useApi();
  const key = ["GET", `/campaign/${id}/excluded-audiences`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.getCampaignExcludedAudiencesById(id);
      // Normalised to `segments` so the excluded selection is interchangeable with the
      // target audience selection and can be fed to the same SegmentList.
      return {
        segments: (result?.data as AudienceIdentitiesView)?.audiences?.map(
          (aud: any) => {
            return {
              segmentType: aud?.audienceType,
              ...aud,
            };
          }
        ) as SegmentIdentityView[],
      };
    },
    options
  );
}

export function useGetCampaignExcludedWorkflowsByIdQuery(
  id: string,
  options?: UseQueryOptions<ExcludedWorkflowsResponseView, Error>
): UseQueryResult<ExcludedWorkflowsResponseView, Error> {
  const api = useApi();
  const key = ["GET", `/campaign/${id}/excluded-workflows`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.getCampaignExcludedWorkflowsById(id);
      return result.data;
    },
    options
  );
}

export function useGetCampaignTrafficShapingByIdQuery(
  id: string,
  options?: UseQueryOptions<AiTrafficShappingIdentitiesView, Error>
): UseQueryResult<AiTrafficShappingIdentitiesView, Error> {
  const api = useApi();
  const key = ["GET", `/campaign/${id}/ai_traffic_control`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.getCampaignTrafficById(id);
      return result.data;
    },
    options
  );
}

export function usePutCampaignSegmentsByIdQuery(
  id: string,

  data: SegmentIdentitiesView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", `/campaign/${id}/audiences`, id, data];
  return useQuery(
    key,
    async () => {
      const result = await api.putCampaignSegmentsById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutCampaignCheckByIdQuery(
  id: string,

  data: CampaignStartView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", `/campaign/${id}/check`, id, data];
  return useQuery(
    key,
    async () => {
      const result = await api.putCampaignCheckById(id, data);
      return result.data;
    },
    options
  );
}

export function useGetCampaignAutoTrackingByIdQuery(
  id: string,

  options?: UseQueryOptions<EnabledView, Error>
): UseQueryResult<EnabledView, Error> {
  const api = useApi();
  const key = ["GET", `/campaign/${id}/auto-tracking`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.getCampaignAutoTrackingById(id);
      return result.data;
    },
    options
  );
}

export function usePutCampaignAutoTrackingByIdQuery(
  id: string,

  data: EnabledView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", `/campaign/${id}/auto-tracking`, id, data];
  return useQuery(
    key,
    async () => {
      const result = await api.putCampaignAutoTrackingById(id, data);
      return result.data;
    },
    options
  );
}

export function useGetCampaignActivitiesByIdQuery(
  id: string,

  options?: UseQueryOptions<ActivityDetailsListView, Error>
): UseQueryResult<ActivityDetailsListView, Error> {
  const api = useApi();
  const key = ["PUT", "/campaign-layout", id];
  return useQuery(
    key,
    async () => {
      const result = await api.getCampaignActivitiesById(id);
      if (result?.data?.html) {
        result.data.templateHtml = result?.data?.html;
      }
      if (result?.data?.css) {
        result.data.templateCss = result?.data?.css;
      }
      if (result?.data?.html || result?.data?.css)
        return { activities: [result.data] };
      else return { activities: [] };
    },
    options
  );
}

export function usePutCampaignActivitiesByIdQuery(
  id: string,

  data: ActivityIdentitiesView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["POST", "/campaign-layout", id, data];
  return useQuery(
    key,
    async () => {
      const result = await api.putCampaignActivitiesById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutCampaignActivitiesEmailMessageByCampaignIdQuery(
  campaignId: string,

  data: ActivityDetailsView,

  options?: UseQueryOptions<IdView, Error>
): UseQueryResult<IdView, Error> {
  const api = useApi();
  const key = ["POST", "/campaign-layout", campaignId, data];
  return useQuery(
    key,
    async () => {
      const result = await api.putCampaignActivitiesEmailMessageByCampaignId(
        campaignId,
        data
      );
      return result.data;
    },
    options
  );
}

export function usePutCampaignSegmentsCheckAssignedQuery(
  data: IdsView,

  options?: UseQueryOptions<IdsView, Error>
): UseQueryResult<IdsView, Error> {
  const api = useApi();
  const key = ["PUT", "/campaign/audiences/check-assigned", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putCampaignSegmentsCheckAssigned(data);
      return result.data;
    },
    options
  );
}

export function usePutCampaignFindFilterQuery(
  data: CampaignFilterView,

  query: { page?: number; size?: number; sort?: string[] },

  options?: UseQueryOptions<PageCampaignInfoView, Error>
): UseQueryResult<PageCampaignInfoView, Error> {
  const api = useApi();
  const key = ["PUT", "/campaign/find/filter", data, query];
  return useQuery(
    key,
    async () => {
      const result = await api.putCampaignFindFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePutCampaignFindFilterBasicQuery(
  data: CampaignFilterView,

  query: { page?: number; size?: number; sort?: string[] },

  options?: UseQueryOptions<PageCampaignInfoViewBasic, Error>
): UseQueryResult<PageCampaignInfoViewBasic, Error> {
  const api = useApi();
  const key = ["PUT", "/campaign/find/filter-campaigns", data, query];
  return useQuery(
    key,
    async () => {
      const result = await api.putCampaignFindFilterBasic(data, query);
      return result.data;
    },
    options
  );
}

export function usePostDomainEngagementsFindFilterQuery(
  data: DomainEngagementFilterView,

  query: { page?: number; size?: number; sort?: string[] },

  options?: UseQueryOptions<PageDomainEngagementInfoView, Error>
): UseQueryResult<PageDomainEngagementInfoView, Error> {
  const api = useApi();
  const key = ["POST", "/campaign/domain-stats/", data, query];
  return useQuery(
    key,
    async () => {
      const result = await api.postDomainEngagementFindFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePostDomainDeliverabilityFindFilterQuery(
  data: DomainDeliverabilityFilterView,

  query: { page?: number; size?: number; sort?: string[] },

  options?: UseQueryOptions<PageDomainDeliverabilityInfoView, Error>
): UseQueryResult<PageDomainDeliverabilityInfoView, Error> {
  const api = useApi();
  const key = ["POST", "/campaign/domain-stats/", data, query];
  return useQuery(
    key,
    async () => {
      const result = await api.postDomainDeliverabilityFindFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePutCampaignFindFilterExportQuery(
  data: CampaignFilterView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", "/campaign/find/filter/export", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putCampaignFindFilterExport(data);
      return result.data;
    },
    options
  );
}

export function useGetActivityByIdQuery(
  id: string,

  options?: UseQueryOptions<ActivityDetailsView, Error>
): UseQueryResult<ActivityDetailsView, Error> {
  const api = useApi();
  const key = ["GET", `/account-html-template/${id}`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.getActivityById(id);
      return result.data;
    },
    options
  );
}

export function usePutActivityByIdQuery(
  id: string,

  data: ActivityDetailsView,

  options?: UseQueryOptions<ActivityIdentityView, Error>
): UseQueryResult<ActivityIdentityView, Error> {
  const api = useApi();
  const key = ["PUT", `/account-html-template/${id}`, id, data];
  return useQuery(
    key,
    async () => {
      const result = await api.putActivityById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutActivityFavoriteByIdAndIsFavoriteQuery(
  id: string,

  isFavorite: boolean,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = [
    "PUT",
    `/account-html-template/${id}/favorite/${isFavorite}`,
    id,
    isFavorite,
  ];
  return useQuery(
    key,
    async () => {
      const result = await api.putActivityFavoriteByIdAndIsFavorite(
        id,
        isFavorite
      );
      return result.data;
    },
    options
  );
}

export function usePutActivityFindFilterQuery(
  data: ActivityFilterView,

  query: { page?: number; size?: number; sort?: string[] },

  options?: UseQueryOptions<PageActivityIdentityView, Error>
): UseQueryResult<PageActivityIdentityView, Error> {
  const api = useApi();
  const key = ["PUT", "/account-html-template/find/filter", data, query];
  return useQuery(
    key,
    async () => {
      const result = await api.putActivityFindFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePutActivityTemplateEmailFavoriteByIdAndIsFavoriteQuery(
  id: string,

  isFavorite: boolean,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = [
    "PUT",
    `/html-template/email/${id}/favorite/${isFavorite}`,
    id,
    isFavorite,
  ];
  return useQuery(
    key,
    async () => {
      const result =
        await api.putActivityTemplateEmailFavoriteByIdAndIsFavorite(
          id,
          isFavorite
        );
      return result.data;
    },
    options
  );
}

export function usePutActivityTemplateEmailFindFilterQuery(
  data: EmailActivityTemplateFilterView,

  query: { page?: number; size?: number; sort?: string[] },

  options?: UseQueryOptions<PageEmailActivityTemplateIdentityView, Error>
): UseQueryResult<PageEmailActivityTemplateIdentityView, Error> {
  const api = useApi();
  const key = ["PUT", "/html-template/email/find/filter", data, query];
  return useQuery(
    key,
    async () => {
      const result = await api.putActivityTemplateEmailFindFilter(data, query);
      return result.data;
    },
    options
  );
}

export function useGetAccountQuery(
  options?: UseQueryOptions<AccountView, Error>
): UseQueryResult<AccountView, Error> {
  const api = useApi();
  const key = ["GET", "/account"];
  return useQuery(
    key,
    async () => {
      const result = await api.getAccount();
      return result.data;
    },
    options
  );
}

export function usePutAccountQuery(
  data: AccountView,

  options?: UseQueryOptions<AccountView, Error>
): UseQueryResult<AccountView, Error> {
  const api = useApi();
  const key = ["PUT", "/account", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putAccount(data);
      return result.data;
    },
    options
  );
}

export function usePostAccountQuery(
  data: AccountCreateView,

  options?: UseQueryOptions<AccountView, Error>
): UseQueryResult<AccountView, Error> {
  const api = useApi();
  const key = ["POST", "/account", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postAccount(data);
      return result.data;
    },
    options
  );
}

export function usePutAccountCanceledByAccountIdQuery(
  accountId: string,

  query: {
    reason: string;
    issueType:
      | "SUBSCRIPTION_PAYMENT"
      | "ACCOUNT_SETUP"
      | "SUBSCRIPTION_LIMIT"
      | "HIGH_BOUNCE_RATE"
      | "HIGH_SPAM_RATE"
      | "HIGH_UNSUBSCRIBE_RATE"
      | "ACCOUNT_ISSUE";
  },

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", `/account/${accountId}/canceled`, accountId, query];
  return useQuery(
    key,
    async () => {
      const result = await api.putAccountCanceledByAccountId(accountId, query);
      return result.data;
    },
    options
  );
}

export function usePutAccountAccountIntegrationExecutionByAccountIdQuery(
  accountId: string,

  data: AccountIntegrationExecutionView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = [
    "PUT",
    `/account/${accountId}/account-integration/execution`,
    accountId,
    data,
  ];
  return useQuery(
    key,
    async () => {
      const result = await api.putAccountAccountIntegrationExecutionByAccountId(
        accountId,
        data
      );
      return result.data;
    },
    options
  );
}

export function usePutAccountNotificationSettingNotificationQuery(
  data: ConfigurableNotificationUpdateView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", "/account/notification-setting/notification", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putAccountNotificationSettingNotification(data);
      return result.data;
    },
    options
  );
}

export function usePutAccountNotificationSettingCategoryQuery(
  data: ConfigurableNotificationCategoryUpdateView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", "/account/notification-setting/category", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putAccountNotificationSettingCategory(data);
      return result.data;
    },
    options
  );
}

export function usePutAccountSubscriptionCalculateCostQuery(
  data: SubscriptionCostCalculateParametersView,

  options?: UseQueryOptions<SubscriptionCostView, Error>
): UseQueryResult<SubscriptionCostView, Error> {
  const api = useApi();
  const key = ["PUT", "/account-subscription/calculate-cost", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putAccountSubscriptionCalculateCost(data);
      return result.data;
    },
    options
  );
}

export function useGetAccountSubscriptionBillingInfoQuery(
  options?: UseQueryOptions<AccountSubscriptionBillingInfoView, Error>
): UseQueryResult<AccountSubscriptionBillingInfoView, Error> {
  const api = useApi();
  const key = ["GET", "/account-subscription/billing-info"];
  return useQuery(
    key,
    async () => {
      const result = await api.getAccountSubscriptionBillingInfo();
      return result.data;
    },
    options
  );
}

export function usePutAccountSubscriptionBillingInfoQuery(
  data: AttachBillingInformationView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", "/account-subscription/billing-info", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putAccountSubscriptionBillingInfo(data);
      return result.data;
    },
    options
  );
}

export function usePutAccountIntegrationTriggerByIntegrationSystemNameQuery(
  integrationSystemName: string,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = [
    "PUT",
    `/account-integration/${integrationSystemName}/trigger`,
    integrationSystemName,
  ];
  return useQuery(
    key,
    async () => {
      const result =
        await api.putAccountIntegrationTriggerByIntegrationSystemName(
          integrationSystemName
        );
      return result.data;
    },
    options
  );
}

export function usePutAccountIntegrationSaveQuery(
  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", "/account-integration/save"];
  return useQuery(
    key,
    async () => {
      const result = await api.putAccountIntegrationSave();
      return result.data;
    },
    options
  );
}

export function usePostTicketQuery(
  data: TicketCreateRequestDto,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["POST", "/ticket", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postTicket(data);
      return result.data;
    },
    options
  );
}

export function useGetSubscriptionLeadQuery(
  options?: UseQueryOptions<LeadView, Error>
): UseQueryResult<LeadView, Error> {
  const api = useApi();
  const key = ["GET", "/subscription/lead"];
  return useQuery(
    key,
    async () => {
      const result = await api.getSubscriptionLead();
      return result.data;
    },
    options
  );
}

export function usePostSubscriptionLeadQuery(
  data: LeadView,

  options?: UseQueryOptions<LeadIdentityView, Error>
): UseQueryResult<LeadIdentityView, Error> {
  const api = useApi();
  const key = ["POST", "/subscription/lead", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postSubscriptionLead(data);
      return result.data;
    },
    options
  );
}

export function usePostSubscriptionAppsumoLicenseQuery(
  options?: UseQueryOptions<LicenseCreatedView, Error>
): UseQueryResult<LicenseCreatedView, Error> {
  const api = useApi();
  const key = ["POST", "/subscription/appsumo/license"];
  return useQuery(
    key,
    async () => {
      const result = await api.postSubscriptionAppsumoLicense();
      return result.data;
    },
    options
  );
}

export function useGetSenderDetailsQuery(
  options?: UseQueryOptions<SenderDetailsesView, Error>
): UseQueryResult<SenderDetailsesView, Error> {
  const api = useApi();
  const key = ["GET", "/sender-details"];
  return useQuery(
    key,
    async () => {
      const result = await api.getSenderDetails();
      return result.data;
    },
    options
  );
}

export function useGetAllCustomFonts(
  options?: UseQueryOptions<CustomFont[], Error>
): UseQueryResult<CustomFont[], Error> {
  const api = useApi();
  const key = ["GET", "/custom-font"];
  return useQuery(
    key,
    async () => {
      const result = await api.getCustomFonts();
      return result.data;
    },
    options
  );
}

export function usePostSenderDetailsQuery(
  data: SenderDetailsCreateView,

  options?: UseQueryOptions<SenderDetailsView, Error>
): UseQueryResult<SenderDetailsView, Error> {
  const api = useApi();
  const key = ["POST", "/sender-details", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postSenderDetails(data);
      return result.data;
    },
    options
  );
}

export function usePostSenderDetailsEmailConfirmTokenBySenderDetailsIdQuery(
  senderDetailsId: string,

  options?: UseQueryOptions<string, Error>
): UseQueryResult<string, Error> {
  const api = useApi();
  const key = [
    "POST",
    `/sender-details/${senderDetailsId}/email-confirm-token`,
    senderDetailsId,
  ];
  return useQuery(
    key,
    async () => {
      const result =
        await api.postSenderDetailsEmailConfirmTokenBySenderDetailsId(
          senderDetailsId
        );
      return result.data;
    },
    options
  );
}

export function usePostSenderDetailsConfirmEmailQuery(
  data: SenderDetailsEmailConfirmationView,

  options?: UseQueryOptions<SenderDetailsView, Error>
): UseQueryResult<SenderDetailsView, Error> {
  const api = useApi();
  const key = ["POST", "/sender-details/confirm-email", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postSenderDetailsConfirmEmail(data);
      return result.data;
    },
    options
  );
}

export function usePostPaymentAccountWebhookQuery(
  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["POST", "/payment-account/webhook"];
  return useQuery(
    key,
    async () => {
      const result = await api.postPaymentAccountWebhook();
      return result.data;
    },
    options
  );
}

export function useGetPaymentAccountPaymentMethodQuery(
  options?: UseQueryOptions<PaymentMethodsView, Error>
): UseQueryResult<PaymentMethodsView, Error> {
  const api = useApi();
  const key = ["GET", "/payment-account/payment-method"];
  return useQuery(
    key,
    async () => {
      const result = await api.getPaymentAccountPaymentMethod();
      return result.data;
    },
    options
  );
}

export function usePostPaymentAccountPaymentMethodQuery(
  data: AttachPaymentMethodView,

  options?: UseQueryOptions<PaymentMethodView, Error>
): UseQueryResult<PaymentMethodView, Error> {
  const api = useApi();
  const key = ["POST", "/payment-account/payment-method", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postPaymentAccountPaymentMethod(data);
      return result.data;
    },
    options
  );
}

export function usePostCampaignQuery(
  data: CampaignCreateRequestView,

  options?: UseQueryOptions<CampaignResponseView, Error>
): UseQueryResult<CampaignResponseView, Error> {
  const api = useApi();
  const key = ["POST", "/campaign/details", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postCampaign(data);
      return result.data;
    },
    options
  );
}

export function usePostCampaignSenderDetailsEmailConfirmTokenByCampaignIdAndSenderDetailsIdQuery(
  campaignId: string,

  senderDetailsId: string,

  options?: UseQueryOptions<string, Error>
): UseQueryResult<string, Error> {
  const api = useApi();
  const key = [
    "POST",
    `/campaign/${campaignId}/sender-details/${senderDetailsId}/email-confirm-token`,
    campaignId,
    senderDetailsId,
  ];
  return useQuery(
    key,
    async () => {
      const result =
        await api.postCampaignSenderDetailsEmailConfirmTokenByCampaignIdAndSenderDetailsId(
          campaignId,
          senderDetailsId
        );
      return result.data;
    },
    options
  );
}

export function usePostCampaignTemplateQuery(
  data: CampaignCreateByTemplateRequestView,

  options?: UseQueryOptions<CampaignResponseView, Error>
): UseQueryResult<CampaignResponseView, Error> {
  const api = useApi();
  const key = ["POST", "/campaign/template", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postCampaignTemplate(data);
      return result.data;
    },
    options
  );
}

export function usePostCampaignStatisticsTotalQuery(
  data: CampaignStatisticsTotalRequestView,

  options?: UseQueryOptions<CampaignStatisticsTotalResponseView, Error>
): UseQueryResult<CampaignStatisticsTotalResponseView, Error> {
  const api = useApi();
  const key = ["POST", "/campaign/statistics/total", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postCampaignStatisticsTotal(data);
      return result.data;
    },
    options
  );
}

export function usePostCampaignStatisticsGroupedQuery(
  data: CampaignStatisticsGroupedRequestView,

  options?: UseQueryOptions<CampaignStatisticsGroupedResponseView, Error>
): UseQueryResult<CampaignStatisticsGroupedResponseView, Error> {
  const api = useApi();
  const key = ["POST", "/campaign/statistics/grouped", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postCampaignStatisticsGrouped(data);
      return result.data;
    },
    options
  );
}

export function usePostCampaignCloneQuery(
  data: CampaignCloneRequestView,

  options?: UseQueryOptions<CampaignResponseView, Error>
): UseQueryResult<CampaignResponseView, Error> {
  const api = useApi();
  const key = ["POST", "/campaign/clone", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postCampaignClone(data);
      return result.data;
    },
    options
  );
}

export function usePostActivityQuery(
  data: ActivityDetailsView,

  options?: UseQueryOptions<ActivityIdentityView, Error>
): UseQueryResult<ActivityIdentityView, Error> {
  const api = useApi();
  const key = ["POST", "/account-html-template", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postActivity(data);
      return result.data;
    },
    options
  );
}

export function usePostAccountAccountIntegrationByAccountIdQuery(
  accountId: string,

  data: AccountIntegrationView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = [
    "POST",
    `/account/${accountId}/account-integration`,
    accountId,
    data,
  ];
  return useQuery(
    key,
    async () => {
      const result = await api.postAccountAccountIntegrationByAccountId(
        accountId,
        data
      );
      return result.data;
    },
    options
  );
}

export function useGetAccountSubscriptionQuery(
  options?: UseQueryOptions<AccountSubscriptionView, Error>
): UseQueryResult<AccountSubscriptionView, Error> {
  const api = useApi();
  const key = ["GET", "/account-subscription"];
  return useQuery(
    key,
    async () => {
      const result = await api.getAccountSubscription();
      return result.data;
    },
    options
  );
}

export function usePostAccountSubscriptionQuery(
  data: AssignSubscriptionView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["POST", "/account-subscription", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postAccountSubscription(data);
      return result.data;
    },
    options
  );
}

export function usePostAccountSubscriptionPaymentMethodQuery(
  data: AssignSubscriptionWithPaymentMethodView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["POST", "/account-subscription/payment-method", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postAccountSubscriptionPaymentMethod(data);
      return result.data;
    },
    options
  );
}

export function usePostAccountSubscriptionPaymentMethodByPaymentMethodIdQuery(
  paymentMethodId: string,

  data: AssignSubscriptionWithBillingInfoView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = [
    "POST",
    `/account-subscription/payment-method/${paymentMethodId}`,
    paymentMethodId,
    data,
  ];
  return useQuery(
    key,
    async () => {
      const result =
        await api.postAccountSubscriptionPaymentMethodByPaymentMethodId(
          paymentMethodId,
          data
        );
      return result.data;
    },
    options
  );
}

export function usePostAccountSubscriptionDefaultQuery(
  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["POST", "/account-subscription/default"];
  return useQuery(
    key,
    async () => {
      const result = await api.postAccountSubscriptionDefault();
      return result.data;
    },
    options
  );
}

export function useGetTemplateTagQuery(
  options?: UseQueryOptions<TemplateTagsView, Error>
): UseQueryResult<TemplateTagsView, Error> {
  const api = useApi();
  const key = ["GET", "/template-tag"];
  return useQuery(
    key,
    async () => {
      const result = await api.getTemplateTag();
      return result.data;
    },
    options
  );
}

export function useGetSubscriptionQuery(
  options?: UseQueryOptions<SubscriptionsView, Error>
): UseQueryResult<SubscriptionsView, Error> {
  const api = useApi();
  const key = ["GET", "/subscription"];
  return useQuery(
    key,
    async () => {
      const result = await api.getSubscription();
      return result.data;
    },
    options
  );
}

export function useGetSubscriptionByTierByTierIdQuery(
  tierId: string,

  options?: UseQueryOptions<SubscriptionView, Error>
): UseQueryResult<SubscriptionView, Error> {
  const api = useApi();
  const key = ["GET", `/subscription/by-tier/${tierId}`, tierId];
  return useQuery(
    key,
    async () => {
      const result = await api.getSubscriptionByTierByTierId(tierId);
      return result.data;
    },
    options
  );
}

export function useGetSubscriptionFeatureAvailableQuery(
  options?: UseQueryOptions<SubscriptionFeaturesAvailabilityView[], Error>
): UseQueryResult<SubscriptionFeaturesAvailabilityView[], Error> {
  const api = useApi();
  const key = ["GET", "/subscription-feature/available"];
  return useQuery(
    key,
    async () => {
      const result = await api.getSubscriptionFeatureAvailable();
      return result.data;
    },
    options
  );
}

export function useGetSubscriptionFeatureAvailableByFeatureSystemNameQuery(
  featureSystemName: string,

  options?: UseQueryOptions<SubscriptionFeaturesAvailabilityView, Error>
): UseQueryResult<SubscriptionFeaturesAvailabilityView, Error> {
  const api = useApi();
  const key = [
    "GET",
    `/subscription-feature/available/${featureSystemName}`,
    featureSystemName,
  ];
  return useQuery(
    key,
    async () => {
      const result =
        await api.getSubscriptionFeatureAvailableByFeatureSystemName(
          featureSystemName
        );
      return result.data;
    },
    options
  );
}

export function useGetSubscriptionFeatureAvailableByCategoriesQuery(
  options?: UseQueryOptions<
    SubscriptionFeaturesCategoriesAvailabilityView[],
    Error
  >
): UseQueryResult<SubscriptionFeaturesCategoriesAvailabilityView[], Error> {
  const api = useApi();
  const key = ["GET", "/subscription-feature/available/by-categories"];
  return useQuery(
    key,
    async () => {
      const result = await api.getSubscriptionFeatureAvailableByCategories();
      return result.data;
    },
    options
  );
}

export function useGetSenderDetailsCheckExistsByNameQuery(
  name: string,

  options?: UseQueryOptions<boolean, Error>
): UseQueryResult<boolean, Error> {
  const api = useApi();
  const key = ["GET", `/sender-details/check-exists/${name}`, name];
  return useQuery(
    key,
    async () => {
      const result = await api.getSenderDetailsCheckExistsByName(name);
      return result.data;
    },
    options
  );
}

export function useGetPaymentAccountInvoiceQuery(
  query: { limit?: number; startAfter?: string },

  options?: UseQueryOptions<InvoicesView, Error>
): UseQueryResult<InvoicesView, Error> {
  const api = useApi();
  const key = ["GET", "/payment-account/invoice", query];
  return useQuery(
    key,
    async () => {
      const result = await api.getPaymentAccountInvoice(query);
      return result.data;
    },
    options
  );
}

export function useGetIntegrationQuery(
  options?: UseQueryOptions<IntegrationsView, Error>
): UseQueryResult<IntegrationsView, Error> {
  const api = useApi();
  const key = ["GET", "/integration"];
  return useQuery(
    key,
    async () => {
      const result = await api.getIntegration();
      return result.data;
    },
    options
  );
}

export function useGetIntegrationProfiledQuery(
  options?: UseQueryOptions<IntegrationsView, Error>
): UseQueryResult<IntegrationsView, Error> {
  const api = useApi();
  const key = ["GET", "/integration/profiled"];
  return useQuery(
    key,
    async () => {
      const result = await api.getIntegrationProfiled();
      return result.data;
    },
    options
  );
}

export function useGetIdentitySocialLinksProfiledQuery(
  options?: UseQueryOptions<SocialLinksView, Error>
): UseQueryResult<SocialLinksView, Error> {
  const api = useApi();
  const key = ["GET", "/identity/social-links/profiled"];
  return useQuery(
    key,
    async () => {
      const result = await api.getIdentitySocialLinksProfiled();
      return result.data;
    },
    options
  );
}

export function useGetIdentityProfiledQuery(
  options?: UseQueryOptions<IdentityProfiledView, Error>
): UseQueryResult<IdentityProfiledView, Error> {
  const api = useApi();
  const key = ["GET", "/identity/profiled"];
  return useQuery(
    key,
    async () => {
      const result = await api.getIdentityProfiled();
      return result.data;
    },
    options
  );
}

export function useGetEditorTokenQuery(
  options?: UseQueryOptions<EditorTokenView, Error>
): UseQueryResult<EditorTokenView, Error> {
  const api = useApi();
  const key = ["GET", "/editor/token"];
  return useQuery(
    key,
    async () => {
      const result = await api.getEditorToken();
      return result.data;
    },
    options
  );
}

export function useGetCampaignEmailFooterByCampaignIdQuery(
  campaignId: string,

  options?: UseQueryOptions<ActivityEmailFooterView, Error>
): UseQueryResult<ActivityEmailFooterView, Error> {
  const api = useApi();
  const key = ["GET", `/campaign/${campaignId}/email/footer`, campaignId];
  return useQuery(
    key,
    async () => {
      const result = await api.getCampaignEmailFooterByCampaignId(campaignId);
      return result.data;
    },
    options
  );
}

export function useGetCampaignActivitiesByCampaignIdAndActivityIdQuery(
  campaignId: string,

  activityId: string,

  options?: UseQueryOptions<ActivityDetailsView, Error>
): UseQueryResult<ActivityDetailsView, Error> {
  const api = useApi();
  const key = ["PUT", "campaign-layout", campaignId, activityId];
  return useQuery(
    key,
    async () => {
      const result = await api.getCampaignActivitiesByCampaignIdAndActivityId(
        campaignId,
        activityId
      );
      return result.data;
    },
    options
  );
}

export function useGetCampaignActivitiesTemplateAttributesByCampaignIdQuery(
  campaignId: string,

  options?: UseQueryOptions<ActivityTemplateAttributesView, Error>
): UseQueryResult<ActivityTemplateAttributesView, Error> {
  const api = useApi();
  const key = [
    "PUT",
    `/campaign/${campaignId}/template-attributes`,
    campaignId,
  ];
  return useQuery(
    key,
    async () => {
      const result =
        await api.getCampaignActivitiesTemplateAttributesByCampaignId(
          campaignId
        );
      return result.data;
    },
    options
  );
}

export function useGetCampaignTemplatesQuery(
  query: { searchTextName: string },

  options?: UseQueryOptions<CampaignIdentitiesView, Error>
): UseQueryResult<CampaignIdentitiesView, Error> {
  const api = useApi();
  const key = ["GET", "/campaign/templates", query];
  return useQuery(
    key,
    async () => {
      const result = await api.getCampaignTemplates(query);
      return result.data;
    },
    options
  );
}

export function useGetActivityTemplateAttributesQuery(
  options?: UseQueryOptions<ActivityTemplateAttributesView, Error>
): UseQueryResult<ActivityTemplateAttributesView, Error> {
  const api = useApi();
  const key = ["GET", "/account-html-template/template-attributes"];
  return useQuery(
    key,
    async () => {
      const result = await api.getActivityTemplateAttributes();
      return result.data;
    },
    options
  );
}

export function useGetActivityEmailFooterQuery(
  options?: UseQueryOptions<ActivityEmailFooterView, Error>
): UseQueryResult<ActivityEmailFooterView, Error> {
  const api = useApi();
  const key = ["GET", "/account-html-template/email/footer"];
  return useQuery(
    key,
    async () => {
      const result = await api.getActivityEmailFooter();
      return result.data;
    },
    options
  );
}

export function useGetActivityTemplateEmailByIdQuery(
  id: string,

  options?: UseQueryOptions<EmailActivityTemplateDetailsView, Error>
): UseQueryResult<EmailActivityTemplateDetailsView, Error> {
  const api = useApi();
  const key = ["GET", `/html-template/email/${id}`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.getActivityTemplateEmailById(id);
      return result.data;
    },
    options
  );
}

export function useGetAccountAccountIntegrationByAccountIdAndIntegrationSystemNameQuery(
  accountId: string,

  integrationSystemName: string,

  options?: UseQueryOptions<AccountIntegrationItemView, Error>
): UseQueryResult<AccountIntegrationItemView, Error> {
  const api = useApi();
  const key = [
    "GET",
    `/account/${accountId}/account-integration/${integrationSystemName}`,
    accountId,
    integrationSystemName,
  ];
  return useQuery(
    key,
    async () => {
      const result =
        await api.getAccountAccountIntegrationByAccountIdAndIntegrationSystemName(
          accountId,
          integrationSystemName
        );
      return result.data;
    },
    options
  );
}

export function useGetAccountProfiledQuery(
  options?: UseQueryOptions<AccountView, Error>
): UseQueryResult<AccountView, Error> {
  const api = useApi();
  const key = ["GET", "/account/profiled"];
  return useQuery(
    key,
    async () => {
      const result = await api.getAccountProfiled();
      return result.data;
    },
    options
  );
}

export function useGetAccountPoweredByCheckExistsQuery(
  options?: UseQueryOptions<boolean, Error>
): UseQueryResult<boolean, Error> {
  const api = useApi();
  const key = ["GET", "/account/powered-by/check-exists"];
  return useQuery(
    key,
    async () => {
      const result = await api.getAccountPoweredByCheckExists();
      return result.data;
    },
    options
  );
}

export function useGetAccountNotificationSettingQuery(
  options?: UseQueryOptions<ConfigurableNotificationSettingsView, Error>
): UseQueryResult<ConfigurableNotificationSettingsView, Error> {
  const api = useApi();
  const key = ["GET", "/account/notification-setting"];
  return useQuery(
    key,
    async () => {
      const result = await api.getAccountNotificationSetting();
      return result.data;
    },
    options
  );
}

export function useGetAccountIssuesQuery(
  options?: UseQueryOptions<AccountIssuesView, Error>
): UseQueryResult<AccountIssuesView, Error> {
  const api = useApi();
  const key = ["GET", "/account/issues"];
  return useQuery(
    key,
    async () => {
      const result = await api.getAccountIssues();
      return result.data;
    },
    options
  );
}

export function useGetAccountSubscriptionLeadQuery(
  options?: UseQueryOptions<AccountLeadSubscriptionView, Error>
): UseQueryResult<AccountLeadSubscriptionView, Error> {
  const api = useApi();
  const key = ["GET", "/account-subscription/lead"];
  return useQuery(
    key,
    async () => {
      const result = await api.getAccountSubscriptionLead();
      return result.data;
    },
    options
  );
}

export function useGetAccountSubscriptionFeaturesQuery(
  options?: UseQueryOptions<SubscriptionFeaturesView, Error>
): UseQueryResult<SubscriptionFeaturesView, Error> {
  const api = useApi();
  const key = ["GET", "/account-subscription/features"];
  return useQuery(
    key,
    async () => {
      const result = await api.getAccountSubscriptionFeatures();
      return result.data;
    },
    options
  );
}

export function useGetAccountSubscriptionFeaturesCategoriesQuery(
  options?: UseQueryOptions<SubscriptionFeaturesCategoriesView, Error>
): UseQueryResult<SubscriptionFeaturesCategoriesView, Error> {
  const api = useApi();
  const key = ["GET", "/account-subscription/features-categories"];
  return useQuery(
    key,
    async () => {
      const result = await api.getAccountSubscriptionFeaturesCategories();
      return result.data;
    },
    options
  );
}

export function useGetAccountIntegrationQuery(
  options?: UseQueryOptions<AccountIntegrationsView, Error>
): UseQueryResult<AccountIntegrationsView, Error> {
  const api = useApi();
  const key = ["GET", "/account-integration"];
  return useQuery(
    key,
    async () => {
      const result = await api.getAccountIntegration();
      return result.data;
    },
    options
  );
}

export function useGetAccountIntegrationByIntegrationSystemNameQuery(
  integrationSystemName: string,

  options?: UseQueryOptions<AccountIntegrationItemView, Error>
): UseQueryResult<AccountIntegrationItemView, Error> {
  const api = useApi();
  const key = [
    "GET",
    `/account-integration/${integrationSystemName}`,
    integrationSystemName,
  ];
  return useQuery(
    key,
    async () => {
      const result = await api.getAccountIntegrationByIntegrationSystemName(
        integrationSystemName
      );
      return result.data;
    },
    options
  );
}

export function useGetAccountIntegrationSummaryQuery(
  options?: UseQueryOptions<AccountIntegrationsSummaryView, Error>
): UseQueryResult<AccountIntegrationsSummaryView, Error> {
  const api = useApi();
  const key = ["GET", "/account-integration/summary"];
  return useQuery(
    key,
    async () => {
      const result = await api.getAccountIntegrationSummary();
      return result.data;
    },
    options
  );
}

export function useGetSegmentBySegmentIdQuery(
  segmentId: string,

  options?: UseQueryOptions<SegmentDetailsView, Error>
): UseQueryResult<SegmentDetailsView, Error> {
  const api = useApi();
  const key = ["GET", `/segment/${segmentId}`, segmentId];
  return useQuery(
    key,
    async () => {
      const result = await api.getSegmentBySegmentId(segmentId);
      return result.data;
    },
    options
  );
}

export function useGetSuppressionBySuppressionIdQuery(
  suppressionId: string,
  options?: UseQueryOptions<SuppressionView, Error>
): UseQueryResult<SuppressionView, Error> {
  const api = useApi();
  const key = [
    "GET",
    `/customer/suppression/suppression/${suppressionId}`,
    suppressionId,
  ];
  return useQuery(
    key,
    async () => {
      const result = await api.getSuppressionBySuppressionId(suppressionId);
      return result.data;
    },
    options
  );
}

export function usePutSegmentBySegmentIdQuery(
  segmentId: string,

  data: SegmentUpdateView,

  options?: UseQueryOptions<SegmentIdentityView1, Error>
): UseQueryResult<SegmentIdentityView1, Error> {
  const api = useApi();
  const key = ["PUT", `/segment/${segmentId}`, segmentId, data];
  return useQuery(
    key,
    async () => {
      const result = await api.putSegmentBySegmentId(segmentId, data);
      return result.data;
    },
    options
  );
}

export function usePutSegmentCustomersBySegmentIdQuery(
  segmentId: string,

  data: CustomersUpdateView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", `/segment/${segmentId}/customers`, segmentId, data];
  return useQuery(
    key,
    async () => {
      const result = await api.putSegmentCustomersBySegmentId(segmentId, data);
      return result.data;
    },
    options
  );
}

export function usePostSegmentCustomersBySegmentIdQuery(
  segmentId: string,

  data: CustomerBatchView,

  options?: UseQueryOptions<SegmentIdentityView1, Error>
): UseQueryResult<SegmentIdentityView1, Error> {
  const api = useApi();
  const key = ["POST", `/segment/${segmentId}/customers`, segmentId, data];
  return useQuery(
    key,
    async () => {
      const result = await api.postSegmentCustomersBySegmentId(segmentId, data);
      return result.data;
    },
    options
  );
}

export function usePutSegmentStatisticByTypeQuery(
  data: SegmentTypeStatisticRequestView,

  options?: UseQueryOptions<SegmentTypeStatisticResponseView, Error>
): UseQueryResult<SegmentTypeStatisticResponseView, Error> {
  const api = useApi();
  const key = ["PUT", "/segment/statistic/by-type", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putSegmentStatisticByType(data);
      return result.data;
    },
    options
  );
}

export function usePutSegmentUniqueCountsByIdsQuery(
  data: SegmentUniqueCountRequestView,
  options?: UseQueryOptions<SegmentUniqueCountResponseView, Error>
): UseQueryResult<SegmentUniqueCountResponseView, Error> {
  const api = useApi();
  const key = ["PUT", "/segment/unique-count", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putSegmentUniqueCountsById(data);
      return result.data;
    },
    options
  );
}

export function usePutSegmentFindIdsQuery(
  data: IdsView,

  options?: UseQueryOptions<SegmentIdentitiesView1, Error>
): UseQueryResult<SegmentIdentitiesView1, Error> {
  const api = useApi();
  const key = ["PUT", "/segment/find/ids", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putSegmentFindIds(data);
      return result.data;
    },
    options
  );
}

export function usePutSegmentFindFilterQuery(
  data: SegmentFilterView,

  query: {
    page?: number;
    size?: number;
    sort?: string[];
    countAllCustomers?: boolean;
  },

  options?: UseQueryOptions<SegmentPageSegmentView, Error>
): UseQueryResult<SegmentPageSegmentView, Error> {
  const api = useApi();
  const key = ["PUT", "/segment/find/filter", data, query];
  return useQuery(
    key,
    async () => {
      const result = await api.putSegmentFindFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePostTrafficShapingQuery(
  data: AITrafficCreateView,

  options?: UseQueryOptions<
    {
      id: string;
    },
    Error
  >
): UseQueryResult<
  {
    id: string;
  },
  Error
> {
  const api = useApi();
  const key = ["POST", "/ai-traffic-control", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postTrafficShapingDetails(data);
      return result.data;
    },
    options
  );
}

export function useTrafficShapingMutation(
  options?: UseMutationOptions<
    { id: string },
    Error,
    AITrafficCreateView,
    { id: string }
  >
): UseMutationResult<
  { id: string },
  Error,
  AITrafficCreateView,
  { id: string }
> {
  const api = useApi();
  return useMutation(async (data: AITrafficCreateView) => {
    const result = await api.postTrafficShapingDetails(data);
    return result.data;
  }, options);
}

export function useGetTrafficShapingQuery(
  query: {
    page?: number;
    size?: number;
    sort?: string[];
    searchTextName?: string;
  },

  options?: UseQueryOptions<AITrafficShapingPageView, Error>
): UseQueryResult<AITrafficShapingPageView, Error> {
  const api = useApi();
  const key = ["GET", "/ai-traffic-control", query];
  return useQuery(
    key,
    async () => {
      const result = await api.getTrafficShapingItems(query);
      return result.data;
    },
    options
  );
}

export function usePutSuppressionFindFilterQuery(
  data: SuppressionFilterView,

  query: {
    page?: number;
    size?: number;
    sort?: string[];
    countAllCustomers?: boolean;
  },

  options?: UseQueryOptions<SuppressionPageSuppressionView, Error>
): UseQueryResult<SuppressionPageSuppressionView, Error> {
  const api = useApi();
  const key = ["PUT", "/segment/find/filter", data, query];
  return useQuery(
    key,
    async () => {
      const result = await api.putSuppressionFindFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePutSegmentCustomSummaryQuery(
  data: CustomSegmentSummaryRequestView,

  options?: UseQueryOptions<CustomSegmentSummaryResponseView, Error>
): UseQueryResult<CustomSegmentSummaryResponseView, Error> {
  const api = useApi();
  const key = ["PUT", "/segment/custom/summary", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putSegmentCustomSummary(data);
      return result.data;
    },
    options
  );
}

export function useGetSegmentCheckExistsQuery(
  query: { name: string },

  options?: UseQueryOptions<boolean, Error>
): UseQueryResult<boolean, Error> {
  const api = useApi();
  const key = ["GET", "/segment/check-exists", query];
  return useQuery(
    key,
    async () => {
      const result = await api.getSegmentCheckExists(query);
      return result.data;
    },
    options
  );
}

export function usePutSegmentCheckExistsQuery(
  data: SegmentCheckExistsFilterView,

  options?: UseQueryOptions<boolean, Error>
): UseQueryResult<boolean, Error> {
  const api = useApi();
  const key = ["PUT", "/segment/check-exists", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putSegmentCheckExists(data);
      return result.data;
    },
    options
  );
}

export function useGetSuppressionCheckExistsQuery(
  suppressionName: string,
  options?: UseQueryOptions<{ exist: boolean }, Error>
): UseQueryResult<{ exist: boolean }, Error> {
  const api = useApi();
  const key = [
    "GET",
    "/customer/suppression/check-exists?name=",
    suppressionName,
  ];
  return useQuery(
    key,
    async () => {
      const result = await api.getSuppressionCheckExistsBySuppressionName(
        suppressionName
      );
      return result.data;
    },
    options
  );
}

export function usePutCustomerByCustomerIdQuery(
  customerId: string,

  data: CustomerView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", `/customer/${customerId}`, customerId, data];
  return useQuery(
    key,
    async () => {
      const result = await api.putCustomerByCustomerId(customerId, data);
      return result.data;
    },
    options
  );
}

export function usePutCustomerStatusByCustomerIdAndCustomerStatusQuery(
  customerId: string,

  customerStatus: string,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = [
    "PUT",
    `/customer/${customerId}/status/${customerStatus}`,
    customerId,
    customerStatus,
  ];
  return useQuery(
    key,
    async () => {
      const result = await api.putCustomerStatusByCustomerIdAndCustomerStatus(
        customerId,
        customerStatus
      );
      return result.data;
    },
    options
  );
}

export function usePutCustomerFilterQuery(
  data: CustomerFilterView,

  query: { page?: number; size?: number; sort?: string[] },

  options?: UseQueryOptions<PageCustomerInfoView, Error>
): UseQueryResult<PageCustomerInfoView, Error> {
  const api = useApi();
  const key = ["PUT", "/customer/filter", data, query];
  return useQuery(
    key,
    async () => {
      const result = await api.putCustomerFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePutSuppressionFilterQuery(
  data: SuppressionDetailsFilterView,

  query: { page?: number; size?: number; sort?: string[] },

  options?: UseQueryOptions<PageSuppressionInfoView, Error>
): UseQueryResult<PageSuppressionInfoView, Error> {
  const api = useApi();
  const key = ["PUT", "/suppression/filter", data, query];
  return useQuery(
    key,
    async () => {
      const result = await api.putSuppressionFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePutCustomerFilterExportQuery(
  data: CustomerFilterView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", "/customer/filter/export", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putCustomerFilterExport(data);
      return result.data;
    },
    options
  );
}

export function usePutCustomerCompositeFilterQuery(
  data: CustomerCompositeFilterView,

  query: { page?: number; size?: number; sort?: string[] },

  options?: UseQueryOptions<PageCustomerInfoView, Error>
): UseQueryResult<PageCustomerInfoView, Error> {
  const api = useApi();
  const key = ["PUT", "/customer/composite-filter", data, query];
  return useQuery(
    key,
    async () => {
      const result = await api.putCustomerCompositeFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePutCustomerActionPlatformInfoFindFilterQuery(
  data: CustomerActionPlatformFindFilterView,

  options?: UseQueryOptions<CustomerActionPlatformInfoView[], Error>
): UseQueryResult<CustomerActionPlatformInfoView[], Error> {
  const api = useApi();
  const key = ["PUT", "/customer-action/platform-info/find/filter", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putCustomerActionPlatformInfoFindFilter(data);
      return result.data;
    },
    options
  );
}

export function usePutCustomerActionGeolocationInfoFindFilterQuery(
  data: CustomerActionGeolocationFindFilterView,

  options?: UseQueryOptions<CustomerActionGeolocationInfoView[], Error>
): UseQueryResult<CustomerActionGeolocationInfoView[], Error> {
  const api = useApi();
  const key = ["PUT", "/customer-action/geolocation-info/find/filter", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putCustomerActionGeolocationInfoFindFilter(data);
      return result.data;
    },
    options
  );
}

export function usePutCustomerActionDomainInfoFindFilterQuery(
  data: CustomerActionDomainFindFilterView,

  options?: UseQueryOptions<CustomerActionDomainInfoView[], Error>
): UseQueryResult<CustomerActionDomainInfoView[], Error> {
  const api = useApi();
  const key = ["PUT", "/customer-action/domain-info/find/filter", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putCustomerActionDomainInfoFindFilter(data);
      return result.data;
    },
    options
  );
}

export function useGetCustomerIspBreakdownQuery(
  options?: UseQueryOptions<IspBreakdownItemView[], Error>
): UseQueryResult<IspBreakdownItemView[], Error> {
  const api = useApi();
  const key = ["GET", "/customer/isp-breakdown"];
  return useQuery(
    key,
    async () => {
      const result = await api.getCustomerIspBreakdown();
      return result.data;
    },
    options
  );
}

export function usePutAccountSegmentCustomerFilterByAccountIdQuery(
  accountId: string,

  data: CustomerSegmentFilterView,

  query: { page?: number; size?: number; sort?: string[] },

  options?: UseQueryOptions<PageCustomerSegmentInfoView, Error>
): UseQueryResult<PageCustomerSegmentInfoView, Error> {
  const api = useApi();
  const key = [
    "PUT",
    `/account/${accountId}/segment-customer/filter`,
    accountId,
    data,
    query,
  ];
  return useQuery(
    key,
    async () => {
      const result = await api.putAccountSegmentCustomerFilterByAccountId(
        accountId,
        data,
        query
      );
      return result.data;
    },
    options
  );
}

export function usePutAccountCustomerFilterByAccountIdQuery(
  accountId: string,

  data: CustomerFilterView,

  query: { page?: number; size?: number; sort?: string[] },

  options?: UseQueryOptions<PageCustomerInfoView, Error>
): UseQueryResult<PageCustomerInfoView, Error> {
  const api = useApi();
  const key = [
    "PUT",
    `/account/${accountId}/customer/filter`,
    accountId,
    data,
    query,
  ];
  return useQuery(
    key,
    async () => {
      const result = await api.putAccountCustomerFilterByAccountId(
        accountId,
        data,
        query
      );
      return result.data;
    },
    options
  );
}

export function usePostSegmentCustomerBySegmentIdQuery(
  segmentId: string,

  data: CustomerView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["POST", `/segment/${segmentId}/customer`, segmentId, data];
  return useQuery(
    key,
    async () => {
      const result = await api.postSegmentCustomerBySegmentId(segmentId, data);
      return result.data;
    },
    options
  );
}

export function usePutMergeAudiencesQuery(
  options?: UseMutationOptions<
    SegmentView,
    Error,
    {
      data: AudienceMergeView;
    },
    unknown
  >
): UseMutationResult<
  SegmentView,
  Error,
  {
    data: AudienceMergeView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: AudienceMergeView }) => {
    const result = await api.putMergeAudiences(data);
    return result.data;
  }, options);
}

export function usePutSegmentMoveQuery(
  options?: UseMutationOptions<
    SegmentMoveResultView,
    Error,
    {
      data: SegmentMoveRequestView;
    },
    unknown
  >
): UseMutationResult<
  SegmentMoveResultView,
  Error,
  {
    data: SegmentMoveRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: SegmentMoveRequestView }) => {
    const result = await api.putSegmentMove(data);
    return result.data;
  }, options);
}

export function usePostSegmentUploadQuery(
  data: UploadSegmentCreateView,

  options?: UseQueryOptions<SegmentIdentityView1, Error>
): UseQueryResult<SegmentIdentityView1, Error> {
  const api = useApi();
  const key = ["POST", "/segment/upload", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postSegmentUpload(data);
      return result.data;
    },
    options
  );
}

export function usePostSegmentUploadCustomerQuery(
  data: CustomerView,

  query: { segmentName: string },

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["POST", "/segment/upload/customer", data, query];
  return useQuery(
    key,
    async () => {
      const result = await api.postSegmentUploadCustomer(data, query);
      return result.data;
    },
    options
  );
}

export function usePostSegmentStatisticsTotalQuery(
  options?: UseQueryOptions<SegmentTotalStatisticsResponseView, Error>
): UseQueryResult<SegmentTotalStatisticsResponseView, Error> {
  const api = useApi();
  const key = ["POST", "/segment/statistics/total"];
  return useQuery(
    key,
    async () => {
      const result = await api.postSegmentStatisticsTotal();
      return result.data;
    },
    options
  );
}

export function usePostSegmentStatisticsTotalCustomersQuery(
  data: SegmentTotalCustomersStatisticsRequestView,

  options?: UseQueryOptions<SegmentTotalCustomersStatisticsResponseView, Error>
): UseQueryResult<SegmentTotalCustomersStatisticsResponseView, Error> {
  const api = useApi();
  const key = ["POST", "/segment/statistics/total-customers", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postSegmentStatisticsTotalCustomers(data);
      return result.data;
    },
    options
  );
}

export function usePostSegmentIntegrationStatisticsGrowthQuery(
  data: IntegrationSegmentStatisticsGrowthRequestView,

  options?: UseQueryOptions<
    IntegrationSegmentStatisticsGrowthResponseView,
    Error
  >
): UseQueryResult<IntegrationSegmentStatisticsGrowthResponseView, Error> {
  const api = useApi();
  const key = ["POST", "/segment/integration/statistics/growth", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postSegmentIntegrationStatisticsGrowth(data);
      return result.data;
    },
    options
  );
}

export function usePostSegmentImportQuery(
  data: SegmentImportView,

  options?: UseQueryOptions<SegmentIdentityView1, Error>
): UseQueryResult<SegmentIdentityView1, Error> {
  const api = useApi();
  const key = ["POST", "/segment/import", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postSegmentImport(data);
      return result.data;
    },
    options
  );
}

export function usePostSegmentCustomQuery(
  data: CustomSegmentCreateView,

  options?: UseQueryOptions<SegmentIdentityView1, Error>
): UseQueryResult<SegmentIdentityView1, Error> {
  const api = useApi();
  const key = ["POST", "/segment/custom", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postSegmentCustom(data);
      return result.data;
    },
    options
  );
}

export function usePostSegmentCloneQuery(
  data: SegmentCloneRequestView,

  options?: UseQueryOptions<SegmentIdentityView1, Error>
): UseQueryResult<SegmentIdentityView1, Error> {
  const api = useApi();
  const key = ["POST", "/segment/clone", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postSegmentClone(data);
      return result.data;
    },
    options
  );
}

export function usePostCustomerStatisticsTotalQuery(
  data: CustomerStatisticsTotalRequestView,

  options?: UseQueryOptions<CustomerStatisticsTotalResponseView, Error>
): UseQueryResult<CustomerStatisticsTotalResponseView, Error> {
  const api = useApi();
  const key = ["POST", "/customer/statistics/total", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postCustomerStatisticsTotal(data);
      return result.data;
    },
    options
  );
}

export function useGetSuppressionStatisticsTotalQuery(
  data: SuppressionStatisticsTotalRequestView,

  options?: UseQueryOptions<SuppressionStatisticsTotalResponseView, Error>
): UseQueryResult<SuppressionStatisticsTotalResponseView, Error> {
  const api = useApi();
  const key = ["GET", "/customer/suppression/statistics/total", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postSuppressionStatisticsTotal(data);
      return result.data;
    },
    options
  );
}

export function usePostCustomerStatisticsGroupedQuery(
  data: CustomerStatisticsGroupedRequestView,

  options?: UseQueryOptions<CustomerStatisticsGroupedResponseView, Error>
): UseQueryResult<CustomerStatisticsGroupedResponseView, Error> {
  const api = useApi();
  const key = ["POST", "/customer/statistics/grouped", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postCustomerStatisticsGrouped(data);
      return result.data;
    },
    options
  );
}

export function usePostCustomerImportQuery(
  data: CustomerBatchView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["POST", "/customer/import", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postCustomerImport(data);
      return result.data;
    },
    options
  );
}

export function usePostCustomerEventStatisticsGroupedQuery(
  data: CustomerEventStatisticsGroupedRequestView,

  options?: UseQueryOptions<CustomerEventStatisticsGroupedResponseView, Error>
): UseQueryResult<CustomerEventStatisticsGroupedResponseView, Error> {
  const api = useApi();
  const key = ["POST", "/customer-event/statistics/grouped", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postCustomerEventStatisticsGrouped(data);
      return result.data;
    },
    options
  );
}

export function usePostCustomerEventCampaignStatisticsTotalByCampaignIdQuery(
  campaignId: string | undefined,

  data: CustomerEventStatisticsTotalRequestView,

  options?: UseQueryOptions<CustomerEventStatisticsTotalResponseView, Error>
): UseQueryResult<CustomerEventStatisticsTotalResponseView, Error> {
  const api = useApi();
  const key = [
    "POST",
    `/customer-event/campaign/${campaignId}/statistics/total`,
    campaignId,
    data,
  ];
  return useQuery(
    key,
    async () => {
      if (campaignId) {
        const result =
          await api.postCustomerEventCampaignStatisticsTotalByCampaignId(
            campaignId,
            data
          );
        return result.data;
      }
      return {} as CustomerEventStatisticsTotalResponseView;
    },
    options
  );
}

export function usePostCustomerEventCampaignStatisticsMostOpenByCampaignIdQuery(
  campaignId: string,

  data: CustomerEventMostOpenStatisticsFilterView,

  query: { offset?: number; limit?: number },

  options?: UseQueryOptions<CustomerEventMostOpenStatisticsResponseView, Error>
): UseQueryResult<CustomerEventMostOpenStatisticsResponseView, Error> {
  const api = useApi();
  const key = [
    "POST",
    `/customer-event/campaign/${campaignId}/statistics/most-open`,
    campaignId,
    data,
    query,
  ];
  return useQuery(
    key,
    async () => {
      const result =
        await api.postCustomerEventCampaignStatisticsMostOpenByCampaignId(
          campaignId,
          data,
          query
        );
      return result.data;
    },
    options
  );
}

export function usePostCustomerEventCampaignStatisticsMostOpenExportByCampaignIdQuery(
  campaignId: string,

  data: CustomerEventMostOpenStatisticsFilterView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = [
    "POST",
    `/customer-event/campaign/${campaignId}/statistics/most-open/export`,
    campaignId,
    data,
  ];
  return useQuery(
    key,
    async () => {
      const result =
        await api.postCustomerEventCampaignStatisticsMostOpenExportByCampaignId(
          campaignId,
          data
        );
      return result.data;
    },
    options
  );
}

export function usePostCustomerEventCampaignStatisticsMostClickByCampaignIdQuery(
  campaignId: string,

  data: CustomerEventMostClickStatisticsFilterView,

  query: { offset?: number; limit?: number },

  options?: UseQueryOptions<CustomerEventMostClickStatisticsResponseView, Error>
): UseQueryResult<CustomerEventMostClickStatisticsResponseView, Error> {
  const api = useApi();
  const key = [
    "POST",
    `/customer-event/campaign/${campaignId}/statistics/most-click`,
    campaignId,
    data,
    query,
  ];
  return useQuery(
    key,
    async () => {
      const result =
        await api.postCustomerEventCampaignStatisticsMostClickByCampaignId(
          campaignId,
          data,
          query
        );
      return result.data;
    },
    options
  );
}

export function usePostCustomerEventCampaignStatisticsMostClickExportByCampaignIdQuery(
  campaignId: string,

  data: CustomerEventMostClickStatisticsFilterView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = [
    "POST",
    `/customer-event/campaign/${campaignId}/statistics/most-click/export`,
    campaignId,
    data,
  ];
  return useQuery(
    key,
    async () => {
      const result =
        await api.postCustomerEventCampaignStatisticsMostClickExportByCampaignId(
          campaignId,
          data
        );
      return result.data;
    },
    options
  );
}

export function usePostCustomerEventCampaignStatisticsGroupedByCampaignIdQuery(
  campaignId: string | undefined,

  data: CustomerEventStatisticsGroupedRequestView,

  options?: UseQueryOptions<CustomerEventStatisticsGroupedResponseView, Error>
): UseQueryResult<CustomerEventStatisticsGroupedResponseView, Error> {
  const api = useApi();
  const key = [
    "POST",
    `/customer-event/campaign/${campaignId}/statistics/grouped`,
    campaignId,
    data,
  ];
  return useQuery(
    key,
    async () => {
      if (campaignId) {
        const result =
          await api.postCustomerEventCampaignStatisticsGroupedByCampaignId(
            campaignId,
            data
          );
        return result.data;
      }
      return {};
    },
    options
  );
}

export function usePostCustomerEventCampaignStatisticsExportByCampaignIdQuery(
  campaignId: string,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = [
    "POST",
    `/customer-event/campaign/${campaignId}/statistics/export`,
    campaignId,
  ];
  return useQuery(
    key,
    async () => {
      const result =
        await api.postCustomerEventCampaignStatisticsExportByCampaignId(
          campaignId
        );
      return result.data;
    },
    options
  );
}

export function usePostAccountSegmentCustomersByAccountIdAndSegmentIdQuery(
  accountId: string,

  segmentId: string,

  data: CustomerBatchView,

  options?: UseQueryOptions<SegmentIdentityView1, Error>
): UseQueryResult<SegmentIdentityView1, Error> {
  const api = useApi();
  const key = [
    "POST",
    `/account/${accountId}/segment/${segmentId}/customers`,
    accountId,
    segmentId,
    data,
  ];
  return useQuery(
    key,
    async () => {
      const result =
        await api.postAccountSegmentCustomersByAccountIdAndSegmentId(
          accountId,
          segmentId,
          data
        );
      return result.data;
    },
    options
  );
}

export function usePostAccountSegmentImportByAccountIdQuery(
  accountId: string,

  data: SegmentImportView,

  options?: UseQueryOptions<SegmentIdentityView1, Error>
): UseQueryResult<SegmentIdentityView1, Error> {
  const api = useApi();
  const key = ["POST", `/account/${accountId}/segment/import`, accountId, data];
  return useQuery(
    key,
    async () => {
      const result = await api.postAccountSegmentImportByAccountId(
        accountId,
        data
      );
      return result.data;
    },
    options
  );
}

export function useGetSegmentCustomCustomersQuery(
  query: { segmentId: string; page?: number; size?: number; sort?: string[] },

  options?: UseQueryOptions<PageCustomerInfoView, Error>
): UseQueryResult<PageCustomerInfoView, Error> {
  const api = useApi();
  const key = ["GET", "/segment/custom/customers", query];
  return useQuery(
    key,
    async () => {
      const result = await api.getSegmentCustomCustomers(query);
      return result.data;
    },
    options
  );
}

export function useGetSegmentConditionsInfoQuery(
  options?: UseQueryOptions<SegmentAttributesView, Error>
): UseQueryResult<SegmentAttributesView, Error> {
  const api = useApi();
  const key = ["GET", "/segment/conditions/info"];
  return useQuery(
    key,
    async () => {
      const result = await api.getSegmentConditionsInfo();
      return result.data;
    },
    options
  );
}

export function useGetSegmentCheckExistsBySegmentNameQuery(
  segmentName: string,

  options?: UseQueryOptions<boolean, Error>
): UseQueryResult<boolean, Error> {
  const api = useApi();
  const key = ["GET", `/segment/check-exists/${segmentName}`, segmentName];
  return useQuery(
    key,
    async () => {
      const result = await api.getSegmentCheckExistsBySegmentName(segmentName);
      return result.data;
    },
    options
  );
}

export function useGetSegmentBySegmentTypeQuery(
  query: {
    searchSegmentType:
      | "UPLOAD"
      | "INTEGRATION"
      | "CUSTOM"
      | "PREDEFINED_RECOMMENDED"
      | "PREDEFINED_LIBRARY";
  },

  options?: UseQueryOptions<SegmentsView, Error>
): UseQueryResult<SegmentsView, Error> {
  const api = useApi();
  const key = ["GET", "/segment/by-segment-type", query];
  return useQuery(
    key,
    async () => {
      const result = await api.getSegmentBySegmentType(query);
      return result.data;
    },
    options
  );
}

export function useGetSegmentByNameQuery(
  query: { searchTextName: string },

  options?: UseQueryOptions<SegmentIdentitiesView1, Error>
): UseQueryResult<SegmentIdentitiesView1, Error> {
  const api = useApi();
  const key = ["GET", "/segment/by-name", query];
  return useQuery(
    key,
    async () => {
      const result = await api.getSegmentByName(query);
      return result.data;
    },
    options
  );
}

export function useGetCustomerTagsQuery(
  options?: UseQueryOptions<TagsView, Error>
): UseQueryResult<TagsView, Error> {
  const api = useApi();
  const key = ["GET", "/customer/tags"];
  return useQuery(
    key,
    async () => {
      const result = await api.getCustomerTags();
      return result.data;
    },
    options
  );
}

export function useGetAccountSegmentByAccountIdQuery(
  accountId: string,

  query: { name: string },

  options?: UseQueryOptions<SegmentView, Error>
): UseQueryResult<SegmentView, Error> {
  const api = useApi();
  const key = ["GET", `/account/${accountId}/segment`, accountId, query];
  return useQuery(
    key,
    async () => {
      const result = await api.getAccountSegmentByAccountId(accountId, query);
      return result.data;
    },
    options
  );
}

export function useGetAccountCustomerByAccountIdQuery(
  accountId: string,

  query: { email: string },

  options?: UseQueryOptions<CustomerInfoView, Error>
): UseQueryResult<CustomerInfoView, Error> {
  const api = useApi();
  const key = ["GET", `/account/${accountId}/customer`, accountId, query];
  return useQuery(
    key,
    async () => {
      const result = await api.getAccountCustomerByAccountId(accountId, query);
      return result.data;
    },
    options
  );
}

export function useGetAccountCustomerTotalByAccountIdQuery(
  accountId: string,

  query: { segmentIds: string[] },

  options?: UseQueryOptions<CustomerTotalView, Error>
): UseQueryResult<CustomerTotalView, Error> {
  const api = useApi();
  const key = ["GET", `/account/${accountId}/customer/total`, accountId, query];
  return useQuery(
    key,
    async () => {
      const result = await api.getAccountCustomerTotalByAccountId(
        accountId,
        query
      );
      return result.data;
    },
    options
  );
}

export function usePutContentSubjectFilterQuery(
  data: SubjectLineFilterView,

  query: { page?: number; size?: number; sort?: string[] },

  options?: UseQueryOptions<PageSubjectLineView, Error>
): UseQueryResult<PageSubjectLineView, Error> {
  const api = useApi();
  const key = ["PUT", "/content/subject/filter", data, query];
  return useQuery(
    key,
    async () => {
      const result = await api.putContentSubjectFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePutContentSubjectFavoriteByIdAndIsFavoriteQuery(
  id: string,

  isFavorite: boolean,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = [
    "PUT",
    `/content/subject/${id}/favorite/${isFavorite}`,
    id,
    isFavorite,
  ];
  return useQuery(
    key,
    async () => {
      const result = await api.putContentSubjectFavoriteByIdAndIsFavorite(
        id,
        isFavorite
      );
      return result.data;
    },
    options
  );
}

export function usePostContentSubjectGenerateQuery(
  data: SubjectGenerateRequestView,

  options?: UseQueryOptions<SubjectGenerateResponseView, Error>
): UseQueryResult<SubjectGenerateResponseView, Error> {
  const api = useApi();
  const key = ["POST", "/content/subject/generate", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postContentSubjectGenerate(data);
      return result.data;
    },
    options
  );
}

export function useGetToneQuery(
  options?: UseQueryOptions<TonesView, Error>
): UseQueryResult<TonesView, Error> {
  const api = useApi();
  const key = ["GET", "/tone"];
  return useQuery(
    key,
    async () => {
      const result = await api.getTone();
      return result.data;
    },
    options
  );
}

export function useGetMergeTagQuery(
  options?: UseQueryOptions<MergeTagsView, Error>
): UseQueryResult<MergeTagsView, Error> {
  const api = useApi();
  const key = ["GET", "/merge-tag"];
  return useQuery(
    key,
    async () => {
      const result = await api.getMergeTag();
      return result.data;
    },
    options
  );
}

export function useGetContentSubjectFeatureQuery(
  options?: UseQueryOptions<SubjectLineFeatureInfoView, Error>
): UseQueryResult<SubjectLineFeatureInfoView, Error> {
  const api = useApi();
  const key = ["GET", "/content/subject/feature"];
  return useQuery(
    key,
    async () => {
      const result = await api.getContentSubjectFeature();
      return result.data;
    },
    options
  );
}

export function usePutFormByIdQuery(
  id: string,

  data: FormUpdateRequestView,

  options?: UseQueryOptions<FormUpdateResponseView, Error>
): UseQueryResult<FormUpdateResponseView, Error> {
  const api = useApi();
  const key = ["PUT", `/form/${id}`, id, data];
  return useQuery(
    key,
    async () => {
      const result = await api.putFormById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutFormStatusByIdAndFormStatusQuery(
  id: string,

  formStatus: string,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", `/form/${id}/status/${formStatus}`, id, formStatus];
  return useQuery(
    key,
    async () => {
      const result = await api.putFormStatusByIdAndFormStatus(id, formStatus);
      return result.data;
    },
    options
  );
}

export function usePutFormFilterQuery(
  data: FormFilterView,

  query: { page?: number; size?: number; sort?: string[] },

  options?: UseQueryOptions<PageFormInfoView, Error>
): UseQueryResult<PageFormInfoView, Error> {
  const api = useApi();
  const key = ["PUT", "/form/filter", data, query];
  return useQuery(
    key,
    async () => {
      const result = await api.putFormFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePutFormConfigQuery(
  data: FormConfigView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", "/form/config/", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putFormConfig(data);
      return result.data;
    },
    options
  );
}

export function usePutFormConfigContentByIdQuery(
  id: string,

  data: FormContentView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", `/form/config/${id}/content`, id, data];
  return useQuery(
    key,
    async () => {
      const result = await api.putFormConfigContentById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutFormConfigAppearanceByIdQuery(
  id: string,

  data: FormAppearanceView,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = ["PUT", `/form/config/${id}/appearance`, id, data];
  return useQuery(
    key,
    async () => {
      const result = await api.putFormConfigAppearanceById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutFormConfigAllowedDomainsByIdQuery(
  id: string,

  data: FormAllowedDomainsView,

  options?: UseQueryOptions<FormAllowedDomainsView, Error>
): UseQueryResult<FormAllowedDomainsView, Error> {
  const api = useApi();
  const key = ["PUT", `/form/config/${id}/allowed-domains`, id, data];
  return useQuery(
    key,
    async () => {
      const result = await api.putFormConfigAllowedDomainsById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutFormCheckAssignedAudiencesQuery(
  data: FormCheckAssignedAudiencesRequestView,

  options?: UseQueryOptions<FormCheckAssignedAudiencesResponseView, Error>
): UseQueryResult<FormCheckAssignedAudiencesResponseView, Error> {
  const api = useApi();
  const key = ["PUT", "/form/check/assigned-audiences", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putFormCheckAssignedAudiences(data);
      return result.data;
    },
    options
  );
}

export function usePutFormTemplateFavoriteByIdAndIsFavoriteQuery(
  id: string,

  isFavorite: boolean,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = [
    "PUT",
    `/form-template/${id}/favorite/${isFavorite}`,
    id,
    isFavorite,
  ];
  return useQuery(
    key,
    async () => {
      const result = await api.putFormTemplateFavoriteByIdAndIsFavorite(
        id,
        isFavorite
      );
      return result.data;
    },
    options
  );
}

export function usePutFormTemplateFilterQuery(
  data: FormTemplateFilterView,

  query: { page?: number; size?: number; sort?: string[] },

  options?: UseQueryOptions<PageFormTemplateInfoView, Error>
): UseQueryResult<PageFormTemplateInfoView, Error> {
  const api = useApi();
  const key = ["PUT", "/form-template/filter", data, query];
  return useQuery(
    key,
    async () => {
      const result = await api.putFormTemplateFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePostFormQuery(
  data: FormView,

  options?: UseQueryOptions<FormIdentityView, Error>
): UseQueryResult<FormIdentityView, Error> {
  const api = useApi();
  const key = ["POST", "/form", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postForm(data);
      return result.data;
    },
    options
  );
}

export function usePostFormCloneQuery(
  data: FormCloneRequestView,

  options?: UseQueryOptions<FormCloneResponseView, Error>
): UseQueryResult<FormCloneResponseView, Error> {
  const api = useApi();
  const key = ["POST", "/form/clone", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postFormClone(data);
      return result.data;
    },
    options
  );
}

export function usePostFormByTemplateQuery(
  data: FormWithTemplateView,

  options?: UseQueryOptions<FormIdentityView, Error>
): UseQueryResult<FormIdentityView, Error> {
  const api = useApi();
  const key = ["POST", "/form/by-template", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postFormByTemplate(data);
      return result.data;
    },
    options
  );
}

export function useGetFormProviderByAccountIdAndFormIdQuery(
  accountId: string,

  formId: string,

  options?: UseQueryOptions<FormPayloadView, Error>
): UseQueryResult<FormPayloadView, Error> {
  const api = useApi();
  const key = [
    "GET",
    `/form-provider/${accountId}/${formId}`,
    accountId,
    formId,
  ];
  return useQuery(
    key,
    async () => {
      const result = await api.getFormProviderByAccountIdAndFormId(
        accountId,
        formId
      );
      return result.data;
    },
    options
  );
}

export function usePostFormProviderByAccountIdAndFormIdQuery(
  accountId: string,

  formId: string,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = [
    "POST",
    `/form-provider/${accountId}/${formId}`,
    accountId,
    formId,
  ];
  return useQuery(
    key,
    async () => {
      const result = await api.postFormProviderByAccountIdAndFormId(
        accountId,
        formId
      );
      return result.data;
    },
    options
  );
}

export function useGetFormConfigByIdQuery(
  id: string,

  options?: UseQueryOptions<FormDetailsView, Error>
): UseQueryResult<FormDetailsView, Error> {
  const api = useApi();
  const key = ["GET", `/form/config/${id}`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.getFormConfigById(id);
      return result.data;
    },
    options
  );
}

export function useGetFormTemplateTagsQuery(
  options?: UseQueryOptions<TemplateTagsView, Error>
): UseQueryResult<TemplateTagsView, Error> {
  const api = useApi();
  const key = ["GET", "/form-template/tags"];
  return useQuery(
    key,
    async () => {
      const result = await api.getFormTemplateTags();
      return result.data;
    },
    options
  );
}

export function usePutAutomationEnabledByAutomationIdAndIsEnabledQuery(
  automationId: string,

  isEnabled: boolean,

  options?: UseQueryOptions<void, Error>
): UseQueryResult<void, Error> {
  const api = useApi();
  const key = [
    "PUT",
    `/automation/${automationId}/enabled/${isEnabled}`,
    automationId,
    isEnabled,
  ];
  return useQuery(
    key,
    async () => {
      const result = await api.putAutomationEnabledByAutomationIdAndIsEnabled(
        automationId,
        isEnabled
      );
      return result.data;
    },
    options
  );
}

export function useGetAutomationQuery(
  options?: UseQueryOptions<AutomationsView, Error>
): UseQueryResult<AutomationsView, Error> {
  const api = useApi();
  const key = ["GET", "/automation"];
  return useQuery(
    key,
    async () => {
      const result = await api.getAutomation();
      return result.data;
    },
    options
  );
}

export function usePutSubscriptionLeadContextEmailMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: LeadIdentityView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: LeadIdentityView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: LeadIdentityView }) => {
    const result = await api.putSubscriptionLeadContextEmail(data);
    return result.data;
  }, options);
}

export function usePutSenderDetailsByIdMutation(
  options?: UseMutationOptions<
    SenderDetailsView,
    Error,
    {
      id: string;

      data: SenderDetailsUpdateView;
    },
    unknown
  >
): UseMutationResult<
  SenderDetailsView,
  Error,
  {
    id: string;

    data: SenderDetailsUpdateView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, data }: { id: string; data: SenderDetailsUpdateView }) => {
      const result = await api.putSenderDetailsById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutMfaEmailOtpSettingMutation(
  options?: UseMutationOptions<
    unknown,
    Error,
    {
      data: MfaEmailOtpRequestView;
    },
    unknown
  >
): UseMutationResult<
  unknown,
  Error,
  {
    data: MfaEmailOtpRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: MfaEmailOtpRequestView }) => {
    const result = await api.putMfaEmailOtpSetting(data);
    return result.data;
  }, options);
}

export function usePutMfaPreferenceMutation(
  options?: UseMutationOptions<
    unknown,
    Error,
    { data: MfaPreferenceRequestView },
    unknown
  >
): UseMutationResult<
  unknown,
  Error,
  { data: MfaPreferenceRequestView },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: MfaPreferenceRequestView }) => {
    const result = await api.putMfaPreference(data);
    return result.data;
  }, options);
}

export function useDeleteAccountMfaMutation(
  options?: UseMutationOptions<void, Error, { type: string }, unknown>
): UseMutationResult<void, Error, { type: string }, unknown> {
  const api = useApi();
  return useMutation(async ({ type }: { type: string }) => {
    const result = await api.deleteAccountMfa(type);
    return result.data;
  }, options);
}

export function useDeleteSenderDetailsByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ id }: { id: string }) => {
    const result = await api.deleteSenderDetailsById(id);
    return result.data;
  }, options);
}

export function useDeleteUserMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ id }: { id: string }) => {
    const result = await api.deleteUserDetailsById(id);
    return result.data;
  }, options);
}

export function usePutSenderDetailsFindFilterMutation(
  options?: UseMutationOptions<
    PageSenderDetailsView,
    Error,
    {
      data: SenderDetailsFilterView;

      query: { page?: number; size?: number; sort?: string[] };
    },
    unknown
  >
): UseMutationResult<
  PageSenderDetailsView,
  Error,
  {
    data: SenderDetailsFilterView;

    query: { page?: number; size?: number; sort?: string[] };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      data,
      query,
    }: {
      data: SenderDetailsFilterView;
      query: { page?: number; size?: number; sort?: string[] };
    }) => {
      const result = await api.putSenderDetailsFindFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePutPaymentAccountPaymentMethodDefaultByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ id }: { id: string }) => {
    const result = await api.putPaymentAccountPaymentMethodDefaultById(id);
    return result.data;
  }, options);
}

export function usePutPaymentAccountInvoicePayByInvoiceIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      invoiceId: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    invoiceId: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ invoiceId }: { invoiceId: string }) => {
    const result = await api.putPaymentAccountInvoicePayByInvoiceId(invoiceId);
    return result.data;
  }, options);
}

export function usePutPaymentAccountInvoiceSendByInvoiceIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      invoiceId: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    invoiceId: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ invoiceId }: { invoiceId: string }) => {
    const result = await api.putPaymentAccountInvoiceSendByInvoiceId(invoiceId);
    return result.data;
  }, options);
}

export function usePutPaymentAccountInvoiceExportMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: ExportInvoicesView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: ExportInvoicesView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: ExportInvoicesView }) => {
    const result = await api.putPaymentAccountInvoiceExport(data);
    return result.data;
  }, options);
}

export function usePutIntegrationFindFilterMutation(
  options?: UseMutationOptions<
    IntegrationsView,
    Error,
    {
      data: IntegrationFilterView;
    },
    unknown
  >
): UseMutationResult<
  IntegrationsView,
  Error,
  {
    data: IntegrationFilterView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: IntegrationFilterView }) => {
    const result = await api.putIntegrationFindFilter(data);
    return result.data;
  }, options);
}

export function usePutIdentityLogoByIdMutation(
  options?: UseMutationOptions<
    IdentityLogoView,
    Error,
    {
      id: string;

      data: { logoFile?: File };
    },
    unknown
  >
): UseMutationResult<
  IdentityLogoView,
  Error,
  {
    id: string;

    data: { logoFile?: File };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, data }: { id: string; data: { logoFile?: File } }) => {
      const result = await api.putIdentityLogoById(id, data);
      return result.data;
    },
    options
  );
}

/**
 * Membership history for the caller's own account, newest first. Requires
 * MANAGE_MEMBERS, and the server only ever returns the caller's account.
 */
export function useGetAccountMemberAuditQuery(
  query: { page?: number; size?: number; sort?: string[] },
  options?: UseQueryOptions<PageAccountMemberAuditView, Error>
): UseQueryResult<PageAccountMemberAuditView, Error> {
  const api = useApi();
  const key = ["GET", "/account-member/audit", query];
  return useQuery(
    key,
    async () => {
      const result = await api.getAccountMemberAudit(query);
      return result.data;
    },
    options
  );
}

/**
 * The caller's own roles and effective permissions, derived from the JWT.
 * Drives every piece of conditional rendering — fetch once per session and keep
 * it in session state rather than re-deriving permissions from a role name.
 */
export function useGetAccountMemberMePermissionsQuery(
  options?: UseQueryOptions<AccountMemberPermissionsView, Error>
): UseQueryResult<AccountMemberPermissionsView, Error> {
  const api = useApi();
  const key = ["GET", "/account-member/me/permissions"];
  return useQuery(
    key,
    async () => {
      const result = await api.getAccountMemberMePermissions();
      return result.data;
    },
    options
  );
}

export function usePostAccountMemberInvitationMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ id }: { id: string }) => {
    const result = await api.postAccountMemberResendInvitation(id);
    return result.data;
  }, options);
}

export function usePostAccountMemberMutation(
  options?: UseMutationOptions<
    UserDetailsView,
    Error,
    {
      data: AccountMemberCreateView;
    },
    unknown
  >
): UseMutationResult<
  UserDetailsView,
  Error,
  {
    data: AccountMemberCreateView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: AccountMemberCreateView }) => {
    const result = await api.postAccountMember(data);
    return result.data;
  }, options);
}

export function usePostAccountSubAccountMutation(
  options?: UseMutationOptions<
    SubAccountView,
    Error,
    {
      data: CreateSubAccountView;
    },
    unknown
  >
): UseMutationResult<
  SubAccountView,
  Error,
  {
    data: CreateSubAccountView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: CreateSubAccountView }) => {
    const result = await api.postAccountSubAccount(data);
    return result.data;
  }, options);
}

export function usePutAccountMemberMutation(
  options?: UseMutationOptions<
    UserDetailsView,
    Error,
    {
      data: AccountMemberUpdateView;
    },
    unknown
  >
): UseMutationResult<
  UserDetailsView,
  Error,
  {
    data: AccountMemberUpdateView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: AccountMemberUpdateView }) => {
    const result = await api.putAccountMember(data);
    return result.data;
  }, options);
}

export function useDeleteIdentityLogoByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ id }: { id: string }) => {
    const result = await api.deleteIdentityLogoById(id);
    return result.data;
  }, options);
}

export function usePutIdentityMutation(
  options?: UseMutationOptions<
    IdentityView,
    Error,
    {
      data: { logoFile?: File; identity: IdentityView };
    },
    unknown
  >
): UseMutationResult<
  IdentityView,
  Error,
  {
    data: { logoFile?: File; identity: IdentityView };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: { logoFile?: File; identity: IdentityView } }) => {
      const result = await api.putIdentity(data);
      return result.data;
    },
    options
  );
}

export function usePutSuppressionMutation(
  options?: UseMutationOptions<
    CreateSuppressionResponseView,
    Error,
    {
      data: { file?: File; suppression: CreateSuppressionRequestView };
    },
    unknown
  >
): UseMutationResult<
  CreateSuppressionResponseView,
  Error,
  {
    data: { file?: File; suppression: CreateSuppressionRequestView };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      data,
    }: {
      data: { file?: File; suppression: CreateSuppressionRequestView };
    }) => {
      const result = await api.postSuppression(data);
      return result.data;
    },
    options
  );
}

export function useAppendSuppressionMutation(
  options?: UseMutationOptions<
    UploadFileView,
    Error,
    { suppressionId: string; file: File },
    unknown
  >
): UseMutationResult<
  UploadFileView,
  Error,
  { suppressionId: string; file: File },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ suppressionId, file }: { suppressionId: string; file: File }) => {
      const result = await api.appendSuppressionFile(suppressionId, { file });
      return result.data;
    },
    options
  );
}

export function usePutSuppressionDetailsMutation(
  options?: UseMutationOptions<
    CreateSuppressionResponseView,
    Error,
    {
      suppressionId: string;
      data: { suppressionValues: suppressionDetailsItem[] };
    },
    unknown
  >
): UseMutationResult<
  CreateSuppressionResponseView,
  Error,
  {
    suppressionId: string;
    data: { suppressionValues: suppressionDetailsItem[] };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      suppressionId,
      data,
    }: {
      suppressionId: string;
      data: { suppressionValues: suppressionDetailsItem[] };
    }) => {
      const result = await api.postSuppressionDetails(suppressionId, data);
      return result.data;
    },
    options
  );
}

export function usePostIdentityMutation(
  options?: UseMutationOptions<
    IdentityView,
    Error,
    {
      data: { logoFile?: File; identity: IdentityView };
    },
    unknown
  >
): UseMutationResult<
  IdentityView,
  Error,
  {
    data: { logoFile?: File; identity: IdentityView };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: { logoFile?: File; identity: IdentityView } }) => {
      const result = await api.postIdentity(data);
      return result.data;
    },
    options
  );
}

export function usePutCampaignByIdMutation(
  options?: UseMutationOptions<
    CampaignResponseView,
    Error,
    {
      id: string;

      data: CampaignUpdateRequestView;
    },
    unknown
  >
): UseMutationResult<
  CampaignResponseView,
  Error,
  {
    id: string;

    data: CampaignUpdateRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, data }: { id: string; data: CampaignUpdateRequestView }) => {
      const result = await api.putCampaignById(id, data);
      return result.data;
    },
    options
  );
}

export function useDeleteCampaignByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ id }: { id: string }) => {
    const result = await api.deleteCampaignById(id);
    return result.data;
  }, options);
}

export function usePutCampaignResumeRecurringByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ id }: { id: string }) => {
    const result = await api.putCampaignResumeRecurringById(id);
    return result.data;
  }, options);
}

export function usePutCampaignStopRecurringByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ id }: { id: string }) => {
    const result = await api.putCampaignStopRecurringById(id);
    return result.data;
  }, options);
}

export function usePutCampaignPauseSendByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ id }: { id: string }) => {
    const result = await api.putCampaignPauseSendById(id);
    return result.data;
  }, options);
}

export function usePutCampaignResumeSendByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ id }: { id: string }) => {
    const result = await api.putCampaignResumeSendById(id);
    return result.data;
  }, options);
}

export function usePutCampaignStopSendByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ id }: { id: string }) => {
    const result = await api.putCampaignStopSendById(id);
    return result.data;
  }, options);
}

export function usePostCampaignCloneUndeliveredByIdMutation(
  options?: UseMutationOptions<
    CampaignCloneUndeliveredResponseView,
    Error,
    {
      id: string;
    },
    unknown
  >
): UseMutationResult<
  CampaignCloneUndeliveredResponseView,
  Error,
  {
    id: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ id }: { id: string }) => {
    const result = await api.postCampaignCloneUndeliveredById(id);
    return result.data;
  }, options);
}

export function usePutCampaignUnscheduleByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ id }: { id: string }) => {
    const result = await api.putCampaignUnscheduleById(id);
    return result.data;
  }, options);
}

export function usePutCampaignTestEmailsByIdMutation(
  options?: UseMutationOptions<
    CampaignRemainedTestEmailsView,
    Error,
    {
      id: string;

      data: CampaignTestEmailsView;
    },
    unknown
  >
): UseMutationResult<
  CampaignRemainedTestEmailsView,
  Error,
  {
    id: string;

    data: CampaignTestEmailsView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, data }: { id: string; data: CampaignTestEmailsView }) => {
      const result = await api.putCampaignTestEmailsById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutCampaignTemplateByIdMutation(
  options?: UseMutationOptions<
    CampaignResponseView,
    Error,
    {
      id: string;
    },
    unknown
  >
): UseMutationResult<
  CampaignResponseView,
  Error,
  {
    id: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ id }: { id: string }) => {
    const result = await api.putCampaignTemplateById(id);
    return result.data;
  }, options);
}

export function usePutCampaignStartByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;

      data: CampaignStartView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;

    data: CampaignStartView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, data }: { id: string; data: CampaignStartView }) => {
      const result = await api.putCampaignStartById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutCampaignSenderDetailsByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;

      data: SenderDetailsIdentityView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;

    data: SenderDetailsIdentityView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, data }: { id: string; data: SenderDetailsIdentityView }) => {
      const result = await api.putCampaignSenderDetailsById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutCampaignContentSourceByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;

      data: CampaignContentSourceRequestView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;

    data: CampaignContentSourceRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      id,
      data,
    }: {
      id: string;
      data: CampaignContentSourceRequestView;
    }) => {
      const result = await api.putCampaignContentSourceById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutCampaignSegmentsByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;

      data: SegmentIdentitiesView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;

    data: SegmentIdentitiesView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, data }: { id: string; data: SegmentIdentitiesView }) => {
      const result = await api.putCampaignSegmentsById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutCampaignTrafficShapingByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;

      data: {
        aiTrafficControlIds: string[];
      };
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;

    data: {
      aiTrafficControlIds: string[];
    };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      id,
      data,
    }: {
      id: string;
      data: {
        aiTrafficControlIds: string[];
      };
    }) => {
      const result = await api.putCampaignTrafficShapingById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutCampaignExcludedAudiencesByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;

      data: SegmentIdentitiesView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;

    data: SegmentIdentitiesView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, data }: { id: string; data: SegmentIdentitiesView }) => {
      const result = await api.putCampaignExcludedAudiencesById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutCampaignExcludedWorkflowsByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;

      data: ExcludedWorkflowsView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;

    data: ExcludedWorkflowsView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, data }: { id: string; data: ExcludedWorkflowsView }) => {
      const result = await api.putCampaignExcludedWorkflowsById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutCampaignSuppressionByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;

      data: string[];
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;

    data: string[];
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ id, data }: { id: string; data: string[] }) => {
    const result = await api.putCampaignSuppressionsById(id, data);
    return result.data;
  }, options);
}

export function usePutCampaignCheckByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;

      data: CampaignStartView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;

    data: CampaignStartView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, data }: { id: string; data: CampaignStartView }) => {
      const result = await api.putCampaignCheckById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutCampaignAutoTrackingByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;

      data: EnabledView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;

    data: EnabledView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, data }: { id: string; data: EnabledView }) => {
      const result = await api.putCampaignAutoTrackingById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutCampaignActivitiesByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;

      data: ActivityIdentitiesView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;

    data: ActivityIdentitiesView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, data }: { id: string; data: ActivityIdentitiesView }) => {
      const result = await api.putCampaignActivitiesById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutCampaignActivitiesEmailMessageByCampaignIdMutation(
  options?: UseMutationOptions<
    IdView,
    Error,
    {
      campaignId: string;

      data: ActivityDetailsView;
    },
    unknown
  >
): UseMutationResult<
  IdView,
  Error,
  {
    campaignId: string;

    data: ActivityDetailsView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      campaignId,
      data,
    }: {
      campaignId: string;
      data: ActivityDetailsView;
    }) => {
      const result = await api.putCampaignActivitiesEmailMessageByCampaignId(
        campaignId,
        data
      );
      return result.data;
    },
    options
  );
}

export function usePutCampaignSegmentsCheckAssignedMutation(
  options?: UseMutationOptions<
    IdsView,
    Error,
    {
      data: IdsView;
    },
    unknown
  >
): UseMutationResult<
  IdsView,
  Error,
  {
    data: IdsView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: IdsView }) => {
    const result = await api.putCampaignSegmentsCheckAssigned(data);
    return result.data;
  }, options);
}

export function usePutCampaignFindFilterMutation(
  options?: UseMutationOptions<
    PageCampaignInfoView,
    Error,
    {
      data: CampaignFilterView;

      query: { page?: number; size?: number; sort?: string[] };
    },
    unknown
  >
): UseMutationResult<
  PageCampaignInfoView,
  Error,
  {
    data: CampaignFilterView;

    query: { page?: number; size?: number; sort?: string[] };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      data,
      query,
    }: {
      data: CampaignFilterView;
      query: { page?: number; size?: number; sort?: string[] };
    }) => {
      const result = await api.putCampaignFindFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePutCampaignFindFilterExportMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: CampaignFilterView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: CampaignFilterView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: CampaignFilterView }) => {
    const result = await api.putCampaignFindFilterExport(data);
    return result.data;
  }, options);
}

export function usePutActivityByIdMutation(
  options?: UseMutationOptions<
    ActivityIdentityView,
    Error,
    {
      id: string;

      data: ActivityDetailsView;
    },
    unknown
  >
): UseMutationResult<
  ActivityIdentityView,
  Error,
  {
    id: string;

    data: ActivityDetailsView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, data }: { id: string; data: ActivityDetailsView }) => {
      const result = await api.putActivityById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutActivityFavoriteByIdAndIsFavoriteMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;

      isFavorite: boolean;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;

    isFavorite: boolean;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, isFavorite }: { id: string; isFavorite: boolean }) => {
      const result = await api.putActivityFavoriteByIdAndIsFavorite(
        id,
        isFavorite
      );
      return result.data;
    },
    options
  );
}

export function usePutActivityFindFilterMutation(
  options?: UseMutationOptions<
    PageActivityIdentityView,
    Error,
    {
      data: ActivityFilterView;

      query: { page?: number; size?: number; sort?: string[] };
    },
    unknown
  >
): UseMutationResult<
  PageActivityIdentityView,
  Error,
  {
    data: ActivityFilterView;

    query: { page?: number; size?: number; sort?: string[] };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      data,
      query,
    }: {
      data: ActivityFilterView;
      query: { page?: number; size?: number; sort?: string[] };
    }) => {
      const result = await api.putActivityFindFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePutActivityTemplateEmailFavoriteByIdAndIsFavoriteMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;

      isFavorite: boolean;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;

    isFavorite: boolean;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, isFavorite }: { id: string; isFavorite: boolean }) => {
      const result =
        await api.putActivityTemplateEmailFavoriteByIdAndIsFavorite(
          id,
          isFavorite
        );
      return result.data;
    },
    options
  );
}

export function usePutActivityTemplateEmailFindFilterMutation(
  options?: UseMutationOptions<
    PageEmailActivityTemplateIdentityView,
    Error,
    {
      data: EmailActivityTemplateFilterView;

      query: { page?: number; size?: number; sort?: string[] };
    },
    unknown
  >
): UseMutationResult<
  PageEmailActivityTemplateIdentityView,
  Error,
  {
    data: EmailActivityTemplateFilterView;

    query: { page?: number; size?: number; sort?: string[] };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      data,
      query,
    }: {
      data: EmailActivityTemplateFilterView;

      query: { page?: number; size?: number; sort?: string[] };
    }) => {
      const result = await api.putActivityTemplateEmailFindFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePutAccountMutation(
  options?: UseMutationOptions<
    AccountView,
    Error,
    {
      data: AccountView;
    },
    unknown
  >
): UseMutationResult<
  AccountView,
  Error,
  {
    data: AccountView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: AccountView }) => {
    const result = await api.putAccount(data);
    return result.data;
  }, options);
}

export function usePostAccountMutation(
  options?: UseMutationOptions<
    AccountView,
    Error,
    {
      data: AccountCreateView;
    },
    unknown
  >
): UseMutationResult<
  AccountView,
  Error,
  {
    data: AccountCreateView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: AccountCreateView }) => {
    const result = await api.postAccount(data);
    return result.data;
  }, options);
}

export function useDeleteAccountMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      query: { email: string };
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    query: { email: string };
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ query }: { query: { email: string } }) => {
    const result = await api.deleteAccount(query);
    return result.data;
  }, options);
}

export function usePutAccountCanceledByAccountIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      accountId: string;

      query: {
        reason: string;
        issueType:
          | "SUBSCRIPTION_PAYMENT"
          | "ACCOUNT_SETUP"
          | "SUBSCRIPTION_LIMIT"
          | "HIGH_BOUNCE_RATE"
          | "HIGH_SPAM_RATE"
          | "HIGH_UNSUBSCRIBE_RATE"
          | "ACCOUNT_ISSUE";
      };
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    accountId: string;

    query: {
      reason: string;
      issueType:
        | "SUBSCRIPTION_PAYMENT"
        | "ACCOUNT_SETUP"
        | "SUBSCRIPTION_LIMIT"
        | "HIGH_BOUNCE_RATE"
        | "HIGH_SPAM_RATE"
        | "HIGH_UNSUBSCRIBE_RATE"
        | "ACCOUNT_ISSUE";
    };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      accountId,
      query,
    }: {
      accountId: string;
      query: {
        reason: string;
        issueType:
          | "SUBSCRIPTION_PAYMENT"
          | "ACCOUNT_SETUP"
          | "SUBSCRIPTION_LIMIT"
          | "HIGH_BOUNCE_RATE"
          | "HIGH_SPAM_RATE"
          | "HIGH_UNSUBSCRIBE_RATE"
          | "ACCOUNT_ISSUE";
      };
    }) => {
      const result = await api.putAccountCanceledByAccountId(accountId, query);
      return result.data;
    },
    options
  );
}

export function usePutAccountAccountIntegrationExecutionByAccountIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      accountId: string;

      data: AccountIntegrationExecutionView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    accountId: string;

    data: AccountIntegrationExecutionView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      accountId,
      data,
    }: {
      accountId: string;
      data: AccountIntegrationExecutionView;
    }) => {
      const result = await api.putAccountAccountIntegrationExecutionByAccountId(
        accountId,
        data
      );
      return result.data;
    },
    options
  );
}

export function usePutAccountNotificationSettingNotificationMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: ConfigurableNotificationUpdateView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: ConfigurableNotificationUpdateView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: ConfigurableNotificationUpdateView }) => {
      const result = await api.putAccountNotificationSettingNotification(data);
      return result.data;
    },
    options
  );
}

export function usePutAccountNotificationSettingCategoryMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: ConfigurableNotificationCategoryUpdateView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: ConfigurableNotificationCategoryUpdateView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: ConfigurableNotificationCategoryUpdateView }) => {
      const result = await api.putAccountNotificationSettingCategory(data);
      return result.data;
    },
    options
  );
}

export function usePutAccountSubscriptionCalculateCostMutation(
  options?: UseMutationOptions<
    SubscriptionCostView,
    Error,
    {
      data: SubscriptionCostCalculateParametersView;
    },
    unknown
  >
): UseMutationResult<
  SubscriptionCostView,
  Error,
  {
    data: SubscriptionCostCalculateParametersView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: SubscriptionCostCalculateParametersView }) => {
      const result = await api.putAccountSubscriptionCalculateCost(data);
      return result.data;
    },
    options
  );
}

export function usePutAccountSubscriptionBillingInfoMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: AttachBillingInformationView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: AttachBillingInformationView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: AttachBillingInformationView }) => {
      const result = await api.putAccountSubscriptionBillingInfo(data);
      return result.data;
    },
    options
  );
}

export function usePutAccountIntegrationTriggerByIntegrationSystemNameMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      integrationSystemName: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    integrationSystemName: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ integrationSystemName }: { integrationSystemName: string }) => {
      const result =
        await api.putAccountIntegrationTriggerByIntegrationSystemName(
          integrationSystemName
        );
      return result.data;
    },
    options
  );
}

export function usePutAccountIntegrationSaveMutation(
  options?: UseMutationOptions<void, Error, void, unknown>
): UseMutationResult<void, Error, void, unknown> {
  const api = useApi();
  return useMutation(async () => {
    const result = await api.putAccountIntegrationSave();
    return result.data;
  }, options);
}

export function usePostTicketMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: TicketCreateRequestDto;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: TicketCreateRequestDto;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: TicketCreateRequestDto }) => {
    const result = await api.postTicket(data);
    return result.data;
  }, options);
}

export function usePostSubscriptionLeadMutation(
  options?: UseMutationOptions<
    LeadIdentityView,
    Error,
    {
      data: LeadView;
    },
    unknown
  >
): UseMutationResult<
  LeadIdentityView,
  Error,
  {
    data: LeadView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: LeadView }) => {
    const result = await api.postSubscriptionLead(data);
    return result.data;
  }, options);
}

export function usePostSubscriptionAppsumoLicenseMutation(
  options?: UseMutationOptions<LicenseCreatedView, Error, void, unknown>
): UseMutationResult<LicenseCreatedView, Error, void, unknown> {
  const api = useApi();
  return useMutation(async () => {
    const result = await api.postSubscriptionAppsumoLicense();
    return result.data;
  }, options);
}

export function usePostSenderDetailsMutation(
  options?: UseMutationOptions<
    SenderDetailsView,
    Error,
    {
      data: SenderDetailsCreateView;
    },
    unknown
  >
): UseMutationResult<
  SenderDetailsView,
  Error,
  {
    data: SenderDetailsCreateView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: SenderDetailsCreateView }) => {
    const result = await api.postSenderDetails(data);
    return result.data;
  }, options);
}

export function useDeleteSenderDetailsMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: SenderDetailsDeleteView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: SenderDetailsDeleteView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: SenderDetailsDeleteView }) => {
    const result = await api.deleteSenderDetails(data);
    return result.data;
  }, options);
}

export function usePostSenderDetailsEmailConfirmTokenBySenderDetailsIdMutation(
  options?: UseMutationOptions<
    string,
    Error,
    {
      senderDetailsId: string;
    },
    unknown
  >
): UseMutationResult<
  string,
  Error,
  {
    senderDetailsId: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ senderDetailsId }: { senderDetailsId: string }) => {
      const result =
        await api.postSenderDetailsEmailConfirmTokenBySenderDetailsId(
          senderDetailsId
        );
      return result.data;
    },
    options
  );
}

export function usePostSenderDetailsConfirmEmailMutation(
  options?: UseMutationOptions<
    SenderDetailsView,
    Error,
    {
      data: SenderDetailsEmailConfirmationView;
    },
    unknown
  >
): UseMutationResult<
  SenderDetailsView,
  Error,
  {
    data: SenderDetailsEmailConfirmationView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: SenderDetailsEmailConfirmationView }) => {
      const result = await api.postSenderDetailsConfirmEmail(data);
      return result.data;
    },
    options
  );
}

export function usePostPaymentAccountWebhookMutation(
  options?: UseMutationOptions<void, Error, void, unknown>
): UseMutationResult<void, Error, void, unknown> {
  const api = useApi();
  return useMutation(async () => {
    const result = await api.postPaymentAccountWebhook();
    return result.data;
  }, options);
}

export function usePostPaymentAccountPaymentMethodMutation(
  options?: UseMutationOptions<
    PaymentMethodView,
    Error,
    {
      data: AttachPaymentMethodView;
    },
    unknown
  >
): UseMutationResult<
  PaymentMethodView,
  Error,
  {
    data: AttachPaymentMethodView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: AttachPaymentMethodView }) => {
    const result = await api.postPaymentAccountPaymentMethod(data);
    return result.data;
  }, options);
}

export function usePostCampaignMutation(
  options?: UseMutationOptions<
    CampaignResponseView,
    Error,
    {
      data: CampaignCreateRequestView;
    },
    unknown
  >
): UseMutationResult<
  CampaignResponseView,
  Error,
  {
    data: CampaignCreateRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: CampaignCreateRequestView }) => {
    const result = await api.postCampaign(data);
    return result.data;
  }, options);
}

export function usePostCustomFontsMutation(
  options?: UseMutationOptions<
    customFontsResponseView,
    Error,
    {
      data: customFontsRequestView;
    },
    unknown
  >
): UseMutationResult<
  customFontsResponseView,
  Error,
  {
    data: customFontsRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: customFontsRequestView }) => {
    const result = await api.postCustomFonts(data);
    return result.data;
  }, options);
}

export function useDeleteCampaignMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: CampaignMultipleDeleteView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: CampaignMultipleDeleteView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: CampaignMultipleDeleteView }) => {
    const result = await api.deleteCampaign(data);
    return result.data;
  }, options);
}

export function usePostCampaignSenderDetailsEmailConfirmTokenByCampaignIdAndSenderDetailsIdMutation(
  options?: UseMutationOptions<
    string,
    Error,
    {
      campaignId: string;

      senderDetailsId: string;
    },
    unknown
  >
): UseMutationResult<
  string,
  Error,
  {
    campaignId: string;

    senderDetailsId: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      campaignId,
      senderDetailsId,
    }: {
      campaignId: string;

      senderDetailsId: string;
    }) => {
      const result =
        await api.postCampaignSenderDetailsEmailConfirmTokenByCampaignIdAndSenderDetailsId(
          campaignId,
          senderDetailsId
        );
      return result.data;
    },
    options
  );
}

export function usePostCampaignTemplateMutation(
  options?: UseMutationOptions<
    CampaignResponseView,
    Error,
    {
      data: CampaignCreateByTemplateRequestView;
    },
    unknown
  >
): UseMutationResult<
  CampaignResponseView,
  Error,
  {
    data: CampaignCreateByTemplateRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: CampaignCreateByTemplateRequestView }) => {
      const result = await api.postCampaignTemplate(data);
      return result.data;
    },
    options
  );
}

export function usePostCampaignStatisticsTotalMutation(
  options?: UseMutationOptions<
    CampaignStatisticsTotalResponseView,
    Error,
    {
      data: CampaignStatisticsTotalRequestView;
    },
    unknown
  >
): UseMutationResult<
  CampaignStatisticsTotalResponseView,
  Error,
  {
    data: CampaignStatisticsTotalRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: CampaignStatisticsTotalRequestView }) => {
      const result = await api.postCampaignStatisticsTotal(data);
      return result.data;
    },
    options
  );
}

export function usePostCampaignStatisticsGroupedMutation(
  options?: UseMutationOptions<
    CampaignStatisticsGroupedResponseView,
    Error,
    {
      data: CampaignStatisticsGroupedRequestView;
    },
    unknown
  >
): UseMutationResult<
  CampaignStatisticsGroupedResponseView,
  Error,
  {
    data: CampaignStatisticsGroupedRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: CampaignStatisticsGroupedRequestView }) => {
      const result = await api.postCampaignStatisticsGrouped(data);
      return result.data;
    },
    options
  );
}

export function usePostCampaignCloneMutation(
  options?: UseMutationOptions<
    CampaignResponseView,
    Error,
    {
      data: CampaignCloneRequestView;
    },
    unknown
  >
): UseMutationResult<
  CampaignResponseView,
  Error,
  {
    data: CampaignCloneRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: CampaignCloneRequestView }) => {
    const result = await api.postCampaignClone(data);
    return result.data;
  }, options);
}

export function useGetCampaignAbTestQuery(
  query: {
    from?: string;
    to?: string;
    page?: number;
    size?: number;
    sort?: string;
  },
  options?: UseQueryOptions<PageAbTestView, Error>
): UseQueryResult<PageAbTestView, Error> {
  const api = useApi();
  const key = ["GET", "/campaign/ab-test", query];
  return useQuery(
    key,
    async () => {
      const result = await api.getCampaignAbTest(query);
      return result.data;
    },
    options
  );
}

export function usePostCampaignAbTestMutation(
  options?: UseMutationOptions<
    AbTestView,
    Error,
    { data: AbTestCreateRequestView },
    unknown
  >
): UseMutationResult<
  AbTestView,
  Error,
  { data: AbTestCreateRequestView },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: AbTestCreateRequestView }) => {
    const result = await api.postCampaignAbTest(data);
    return result.data;
  }, options);
}

export function useGetCampaignAbTestByIdQuery(
  abTestId: string,
  options?: UseQueryOptions<AbTestView, Error>
): UseQueryResult<AbTestView, Error> {
  const api = useApi();
  const key = ["GET", "/campaign/ab-test/{abTestId}", abTestId];
  return useQuery(
    key,
    async () => {
      const result = await api.getCampaignAbTestById(abTestId);
      return result.data;
    },
    options
  );
}

export function usePatchCampaignAbTestByIdMutation(
  options?: UseMutationOptions<
    AbTestView,
    Error,
    { abTestId: string; data: AbTestUpdateRequestView },
    unknown
  >
): UseMutationResult<
  AbTestView,
  Error,
  { abTestId: string; data: AbTestUpdateRequestView },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      abTestId,
      data,
    }: {
      abTestId: string;
      data: AbTestUpdateRequestView;
    }) => {
      const result = await api.patchCampaignAbTestById(abTestId, data);
      return result.data;
    },
    options
  );
}

export function usePatchCampaignAbTestVariationsByIdMutation(
  options?: UseMutationOptions<
    AbTestView,
    Error,
    { abTestId: string; data: AbTestVariationsRequestView },
    unknown
  >
): UseMutationResult<
  AbTestView,
  Error,
  { abTestId: string; data: AbTestVariationsRequestView },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      abTestId,
      data,
    }: {
      abTestId: string;
      data: AbTestVariationsRequestView;
    }) => {
      const result = await api.patchCampaignAbTestVariationsById(
        abTestId,
        data
      );
      return result.data;
    },
    options
  );
}

export function useDeleteCampaignAbTestByIdMutation(
  options?: UseMutationOptions<void, Error, { abTestId: string }, unknown>
): UseMutationResult<void, Error, { abTestId: string }, unknown> {
  const api = useApi();
  return useMutation(async ({ abTestId }: { abTestId: string }) => {
    const result = await api.deleteCampaignAbTestById(abTestId);
    return result.data;
  }, options);
}

export function usePostActivityMutation(
  options?: UseMutationOptions<
    ActivityIdentityView,
    Error,
    {
      data: ActivityDetailsView;
    },
    unknown
  >
): UseMutationResult<
  ActivityIdentityView,
  Error,
  {
    data: ActivityDetailsView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: ActivityDetailsView }) => {
    const result = await api.postActivity(data);
    return result.data;
  }, options);
}

export function useDeleteActivityMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: ActivityMultipleDeleteView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: ActivityMultipleDeleteView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: ActivityMultipleDeleteView }) => {
    const result = await api.deleteActivity(data);
    return result.data;
  }, options);
}

export function usePostAccountAccountIntegrationByAccountIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      accountId: string;

      data: AccountIntegrationView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    accountId: string;

    data: AccountIntegrationView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      accountId,
      data,
    }: {
      accountId: string;
      data: AccountIntegrationView;
    }) => {
      const result = await api.postAccountAccountIntegrationByAccountId(
        accountId,
        data
      );
      return result.data;
    },
    options
  );
}

export function usePostAccountSubscriptionMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: AssignSubscriptionView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: AssignSubscriptionView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: AssignSubscriptionView }) => {
    const result = await api.postAccountSubscription(data);
    return result.data;
  }, options);
}

export function usePostAccountSubscriptionPaymentMethodMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: AssignSubscriptionWithPaymentMethodView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: AssignSubscriptionWithPaymentMethodView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: AssignSubscriptionWithPaymentMethodView }) => {
      const result = await api.postAccountSubscriptionPaymentMethod(data);
      return result.data;
    },
    options
  );
}

export function usePostAccountSubscriptionPaymentMethodByPaymentMethodIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      paymentMethodId: string;

      data: AssignSubscriptionWithBillingInfoView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    paymentMethodId: string;

    data: AssignSubscriptionWithBillingInfoView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      paymentMethodId,
      data,
    }: {
      paymentMethodId: string;

      data: AssignSubscriptionWithBillingInfoView;
    }) => {
      const result =
        await api.postAccountSubscriptionPaymentMethodByPaymentMethodId(
          paymentMethodId,
          data
        );
      return result.data;
    },
    options
  );
}

export function usePostAccountSubscriptionDefaultMutation(
  options?: UseMutationOptions<void, Error, void, unknown>
): UseMutationResult<void, Error, void, unknown> {
  const api = useApi();
  return useMutation(async () => {
    const result = await api.postAccountSubscriptionDefault();
    return result.data;
  }, options);
}

export function useDeletePaymentAccountPaymentMethodByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ id }: { id: string }) => {
    const result = await api.deletePaymentAccountPaymentMethodById(id);
    return result.data;
  }, options);
}

export function useDeleteCampaignActivitiesEmailMessageByCampaignIdAndEmailMessageIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      campaignId: string;

      emailMessageId: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    campaignId: string;

    emailMessageId: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      campaignId,
      emailMessageId,
    }: {
      campaignId: string;

      emailMessageId: string;
    }) => {
      const result =
        await api.deleteCampaignActivitiesEmailMessageByCampaignIdAndEmailMessageId(
          campaignId,
          emailMessageId
        );
      return result.data;
    },
    options
  );
}

export function useDeleteCampaignSegmentMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: SegmentIdentityView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: SegmentIdentityView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: SegmentIdentityView }) => {
    const result = await api.deleteCampaignSegment(data);
    return result.data;
  }, options);
}

export function useDeleteCampaignSegmentsMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: IdsView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: IdsView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: IdsView }) => {
    const result = await api.deleteCampaignSegments(data);
    return result.data;
  }, options);
}

export function useDeleteAccountIntegrationByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ id }: { id: string }) => {
    const result = await api.deleteAccountIntegrationById(id);
    return result.data;
  }, options);
}

export function usePutSegmentBySegmentIdMutation(
  options?: UseMutationOptions<
    SegmentIdentityView1,
    Error,
    {
      segmentId: string;

      data: SegmentUpdateView;
    },
    unknown
  >
): UseMutationResult<
  SegmentIdentityView1,
  Error,
  {
    segmentId: string;

    data: SegmentUpdateView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      segmentId,
      data,
    }: {
      segmentId: string;
      data: SegmentUpdateView;
    }) => {
      const result = await api.putSegmentBySegmentId(segmentId, data);
      return result.data;
    },
    options
  );
}

export function usePutSuppressionBySuppressionIdMutation(
  options?: UseMutationOptions<
    SuppressionView,
    Error,
    {
      suppressionId: string;

      data: SuppressionUpdateView;
    },
    unknown
  >
): UseMutationResult<
  SuppressionView,
  Error,
  {
    suppressionId: string;

    data: SuppressionUpdateView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      suppressionId,
      data,
    }: {
      suppressionId: string;
      data: SegmentUpdateView;
    }) => {
      const result = await api.putSuppressionBySuppressionId(
        suppressionId,
        data
      );
      return result.data;
    },
    options
  );
}

export function useDeleteSegmentBySegmentIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      segmentId: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    segmentId: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ segmentId }: { segmentId: string }) => {
    const result = await api.deleteSegmentBySegmentId(segmentId);
    return result.data;
  }, options);
}

export function useDeleteTrafficShapingMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ id }: { id: string }) => {
    const result = await api.deleteTrafficShapingId(id);
    return result.data;
  }, options);
}

export function useResetTrafficShapingMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ id }: { id: string }) => {
    const result = await api.resetTrafficShapingId(id);
    return result.data;
  }, options);
}

export function useActivateRecurringAITrafficShapingMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;
      activateRecurring: boolean;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;
    activateRecurring: boolean;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      id,
      activateRecurring,
    }: {
      id: string;
      activateRecurring: boolean;
    }) => {
      const result = await api.activateRecurringTrafficShapingId(
        id,
        activateRecurring
      );
      return result.data;
    },
    options
  );
}

export function usePutSegmentCustomersBySegmentIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      segmentId: string;

      data: CustomersUpdateView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    segmentId: string;

    data: CustomersUpdateView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      segmentId,
      data,
    }: {
      segmentId: string;
      data: CustomersUpdateView;
    }) => {
      const result = await api.putSegmentCustomersBySegmentId(segmentId, data);
      return result.data;
    },
    options
  );
}

export function usePostSegmentCustomersBySegmentIdMutation(
  options?: UseMutationOptions<
    SegmentIdentityView1,
    Error,
    {
      segmentId: string;

      data: CustomerBatchView;
    },
    unknown
  >
): UseMutationResult<
  SegmentIdentityView1,
  Error,
  {
    segmentId: string;

    data: CustomerBatchView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      segmentId,
      data,
    }: {
      segmentId: string;
      data: CustomerBatchView;
    }) => {
      const result = await api.postSegmentCustomersBySegmentId(segmentId, data);
      return result.data;
    },
    options
  );
}

export function usePutSegmentStatisticByTypeMutation(
  options?: UseMutationOptions<
    SegmentTypeStatisticResponseView,
    Error,
    {
      data: SegmentTypeStatisticRequestView;
    },
    unknown
  >
): UseMutationResult<
  SegmentTypeStatisticResponseView,
  Error,
  {
    data: SegmentTypeStatisticRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: SegmentTypeStatisticRequestView }) => {
      const result = await api.putSegmentStatisticByType(data);
      return result.data;
    },
    options
  );
}

export function usePutSegmentFindIdsMutation(
  options?: UseMutationOptions<
    SegmentIdentitiesView1,
    Error,
    {
      data: IdsView;
    },
    unknown
  >
): UseMutationResult<
  SegmentIdentitiesView1,
  Error,
  {
    data: IdsView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: IdsView }) => {
    const result = await api.putSegmentFindIds(data);
    return result.data;
  }, options);
}

export function usePutSegmentFindFilterMutation(
  options?: UseMutationOptions<
    SegmentPageSegmentView,
    Error,
    {
      data: SegmentFilterView;

      query: {
        page?: number;
        size?: number;
        sort?: string[];
        countAllCustomers?: boolean;
      };
    },
    unknown
  >
): UseMutationResult<
  SegmentPageSegmentView,
  Error,
  {
    data: SegmentFilterView;

    query: {
      page?: number;
      size?: number;
      sort?: string[];
      countAllCustomers?: boolean;
    };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      data,
      query,
    }: {
      data: SegmentFilterView;
      query: {
        page?: number;
        size?: number;
        sort?: string[];
        countAllCustomers?: boolean;
      };
    }) => {
      const result = await api.putSegmentFindFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePutSegmentCustomSummaryMutation(
  options?: UseMutationOptions<
    CustomSegmentSummaryResponseView,
    Error,
    {
      data: CustomSegmentSummaryRequestView;
    },
    unknown
  >
): UseMutationResult<
  CustomSegmentSummaryResponseView,
  Error,
  {
    data: CustomSegmentSummaryRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: CustomSegmentSummaryRequestView }) => {
      const result = await api.putSegmentCustomSummary(data);
      return result.data;
    },
    options
  );
}

export function usePutSegmentCheckExistsMutation(
  options?: UseMutationOptions<
    boolean,
    Error,
    {
      data: SegmentCheckExistsFilterView;
    },
    unknown
  >
): UseMutationResult<
  boolean,
  Error,
  {
    data: SegmentCheckExistsFilterView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: SegmentCheckExistsFilterView }) => {
      const result = await api.putSegmentCheckExists(data);
      return result.data;
    },
    options
  );
}

export function usePutCustomerByCustomerIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      customerId: string;

      data: CustomerView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    customerId: string;

    data: CustomerView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      customerId,
      data,
    }: {
      customerId: string;
      data: CustomerView;
    }) => {
      const result = await api.putCustomerByCustomerId(customerId, data);
      return result.data;
    },
    options
  );
}

export function usePutCustomerStatusByCustomerIdAndCustomerStatusMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      customerId: string;

      customerStatus: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    customerId: string;

    customerStatus: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      customerId,
      customerStatus,
    }: {
      customerId: string;

      customerStatus: string;
    }) => {
      const result = await api.putCustomerStatusByCustomerIdAndCustomerStatus(
        customerId,
        customerStatus
      );
      return result.data;
    },
    options
  );
}

export function usePutCustomerUpdateStatusMutation(
  options?: UseMutationOptions<void, Error, CustomerStatusUpdateView, unknown>
): UseMutationResult<void, Error, CustomerStatusUpdateView, unknown> {
  const api = useApi();
  return useMutation(async (data: CustomerStatusUpdateView) => {
    const result = await api.putCustomerUpdateStatus(data);
    return result.data;
  }, options);
}

export function usePutCustomerFilterMutation(
  options?: UseMutationOptions<
    PageCustomerInfoView,
    Error,
    {
      data: CustomerFilterView;

      query: { page?: number; size?: number; sort?: string[] };
    },
    unknown
  >
): UseMutationResult<
  PageCustomerInfoView,
  Error,
  {
    data: CustomerFilterView;

    query: { page?: number; size?: number; sort?: string[] };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      data,
      query,
    }: {
      data: CustomerFilterView;
      query: { page?: number; size?: number; sort?: string[] };
    }) => {
      const result = await api.putCustomerFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePutCustomerFilterExportMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: CustomerFilterView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: CustomerFilterView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: CustomerFilterView }) => {
    const result = await api.putCustomerFilterExport(data);
    return result.data;
  }, options);
}

export function usePutCustomerCompositeFilterMutation(
  options?: UseMutationOptions<
    PageCustomerInfoView,
    Error,
    {
      data: CustomerCompositeFilterView;

      query: { page?: number; size?: number; sort?: string[] };
    },
    unknown
  >
): UseMutationResult<
  PageCustomerInfoView,
  Error,
  {
    data: CustomerCompositeFilterView;

    query: { page?: number; size?: number; sort?: string[] };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      data,
      query,
    }: {
      data: CustomerCompositeFilterView;

      query: { page?: number; size?: number; sort?: string[] };
    }) => {
      const result = await api.putCustomerCompositeFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePutCustomerActionPlatformInfoFindFilterMutation(
  options?: UseMutationOptions<
    CustomerActionPlatformInfoView[],
    Error,
    {
      data: CustomerActionPlatformFindFilterView;
    },
    unknown
  >
): UseMutationResult<
  CustomerActionPlatformInfoView[],
  Error,
  {
    data: CustomerActionPlatformFindFilterView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: CustomerActionPlatformFindFilterView }) => {
      const result = await api.putCustomerActionPlatformInfoFindFilter(data);
      return result.data;
    },
    options
  );
}

export function usePutCustomerActionGeolocationInfoFindFilterMutation(
  options?: UseMutationOptions<
    CustomerActionGeolocationInfoView[],
    Error,
    {
      data: CustomerActionGeolocationFindFilterView;
    },
    unknown
  >
): UseMutationResult<
  CustomerActionGeolocationInfoView[],
  Error,
  {
    data: CustomerActionGeolocationFindFilterView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: CustomerActionGeolocationFindFilterView }) => {
      const result = await api.putCustomerActionGeolocationInfoFindFilter(data);
      return result.data;
    },
    options
  );
}

export function usePutCustomerActionDomainInfoFindFilterMutation(
  options?: UseMutationOptions<
    CustomerActionDomainInfoView[],
    Error,
    {
      data: CustomerActionDomainFindFilterView;
    },
    unknown
  >
): UseMutationResult<
  CustomerActionDomainInfoView[],
  Error,
  {
    data: CustomerActionDomainFindFilterView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: CustomerActionDomainFindFilterView }) => {
      const result = await api.putCustomerActionDomainInfoFindFilter(data);
      return result.data;
    },
    options
  );
}

export function usePutAccountSegmentCustomerFilterByAccountIdMutation(
  options?: UseMutationOptions<
    PageCustomerSegmentInfoView,
    Error,
    {
      accountId: string;

      data: CustomerSegmentFilterView;

      query: { page?: number; size?: number; sort?: string[] };
    },
    unknown
  >
): UseMutationResult<
  PageCustomerSegmentInfoView,
  Error,
  {
    accountId: string;

    data: CustomerSegmentFilterView;

    query: { page?: number; size?: number; sort?: string[] };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      accountId,
      data,
      query,
    }: {
      accountId: string;
      data: CustomerSegmentFilterView;
      query: { page?: number; size?: number; sort?: string[] };
    }) => {
      const result = await api.putAccountSegmentCustomerFilterByAccountId(
        accountId,
        data,
        query
      );
      return result.data;
    },
    options
  );
}

export function usePutAccountCustomerFilterByAccountIdMutation(
  options?: UseMutationOptions<
    PageCustomerInfoView,
    Error,
    {
      accountId: string;

      data: CustomerFilterView;

      query: { page?: number; size?: number; sort?: string[] };
    },
    unknown
  >
): UseMutationResult<
  PageCustomerInfoView,
  Error,
  {
    accountId: string;

    data: CustomerFilterView;

    query: { page?: number; size?: number; sort?: string[] };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      accountId,
      data,
      query,
    }: {
      accountId: string;
      data: CustomerFilterView;
      query: { page?: number; size?: number; sort?: string[] };
    }) => {
      const result = await api.putAccountCustomerFilterByAccountId(
        accountId,
        data,
        query
      );
      return result.data;
    },
    options
  );
}

export function usePostSegmentCustomerBySegmentIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      segmentId: string;

      data: CustomerView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    segmentId: string;

    data: CustomerView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ segmentId, data }: { segmentId: string; data: CustomerView }) => {
      const result = await api.postSegmentCustomerBySegmentId(segmentId, data);
      return result.data;
    },
    options
  );
}

export function useDeleteSegmentCustomerBySegmentIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      segmentId: string;

      data: SegmentUnassignCustomersView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    segmentId: string;

    data: SegmentUnassignCustomersView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      segmentId,
      data,
    }: {
      segmentId: string;
      data: SegmentUnassignCustomersView;
    }) => {
      const result = await api.deleteSegmentCustomerBySegmentId(
        segmentId,
        data
      );
      return result.data;
    },
    options
  );
}

export function usePostSegmentUploadMutation(
  options?: UseMutationOptions<
    SegmentIdentityView1,
    Error,
    {
      data: UploadSegmentCreateView;
    },
    unknown
  >
): UseMutationResult<
  SegmentIdentityView1,
  Error,
  {
    data: UploadSegmentCreateView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: UploadSegmentCreateView }) => {
    const result = await api.postSegmentUpload(data);
    return result.data;
  }, options);
}

export function usePostSegmentUploadCustomerMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: CustomerView;

      query: { segmentName: string };
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: CustomerView;

    query: { segmentName: string };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      data,
      query,
    }: {
      data: CustomerView;
      query: { segmentName: string };
    }) => {
      const result = await api.postSegmentUploadCustomer(data, query);
      return result.data;
    },
    options
  );
}

export function usePostSegmentStatisticsTotalMutation(
  options?: UseMutationOptions<
    SegmentTotalStatisticsResponseView,
    Error,
    void,
    unknown
  >
): UseMutationResult<SegmentTotalStatisticsResponseView, Error, void, unknown> {
  const api = useApi();
  return useMutation(async () => {
    const result = await api.postSegmentStatisticsTotal();
    return result.data;
  }, options);
}

export function usePostSegmentStatisticsTotalCustomersMutation(
  options?: UseMutationOptions<
    SegmentTotalCustomersStatisticsResponseView,
    Error,
    {
      data: SegmentTotalCustomersStatisticsRequestView;
    },
    unknown
  >
): UseMutationResult<
  SegmentTotalCustomersStatisticsResponseView,
  Error,
  {
    data: SegmentTotalCustomersStatisticsRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: SegmentTotalCustomersStatisticsRequestView }) => {
      const result = await api.postSegmentStatisticsTotalCustomers(data);
      return result.data;
    },
    options
  );
}

export function usePostSegmentIntegrationStatisticsGrowthMutation(
  options?: UseMutationOptions<
    IntegrationSegmentStatisticsGrowthResponseView,
    Error,
    {
      data: IntegrationSegmentStatisticsGrowthRequestView;
    },
    unknown
  >
): UseMutationResult<
  IntegrationSegmentStatisticsGrowthResponseView,
  Error,
  {
    data: IntegrationSegmentStatisticsGrowthRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      data,
    }: {
      data: IntegrationSegmentStatisticsGrowthRequestView;
    }) => {
      const result = await api.postSegmentIntegrationStatisticsGrowth(data);
      return result.data;
    },
    options
  );
}

export function usePostSegmentImportMutation(
  options?: UseMutationOptions<
    SegmentIdentityView1,
    Error,
    {
      data: SegmentImportView;
    },
    unknown
  >
): UseMutationResult<
  SegmentIdentityView1,
  Error,
  {
    data: SegmentImportView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: SegmentImportView }) => {
    const result = await api.postSegmentImport(data);
    return result.data;
  }, options);
}

export function usePostSegmentCustomMutation(
  options?: UseMutationOptions<
    SegmentIdentityView1,
    Error,
    {
      data: CustomSegmentCreateView;
    },
    unknown
  >
): UseMutationResult<
  SegmentIdentityView1,
  Error,
  {
    data: CustomSegmentCreateView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: CustomSegmentCreateView }) => {
    const result = await api.postSegmentCustom(data);
    return result.data;
  }, options);
}

export function usePostExportToStaticSegment(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: ExportSegmentCreateView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: ExportSegmentCreateView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: ExportSegmentCreateView }) => {
    const result = await api.postExportToStaticSegment(data);
    return result.data;
  }, options);
}

export function usePostSegmentCloneMutation(
  options?: UseMutationOptions<
    SegmentIdentityView1,
    Error,
    {
      data: SegmentCloneRequestView;
    },
    unknown
  >
): UseMutationResult<
  SegmentIdentityView1,
  Error,
  {
    data: SegmentCloneRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: SegmentCloneRequestView }) => {
    const result = await api.postSegmentClone(data);
    return result.data;
  }, options);
}

export function usePostCustomerStatisticsTotalMutation(
  options?: UseMutationOptions<
    CustomerStatisticsTotalResponseView,
    Error,
    {
      data: CustomerStatisticsTotalRequestView;
    },
    unknown
  >
): UseMutationResult<
  CustomerStatisticsTotalResponseView,
  Error,
  {
    data: CustomerStatisticsTotalRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: CustomerStatisticsTotalRequestView }) => {
      const result = await api.postCustomerStatisticsTotal(data);
      return result.data;
    },
    options
  );
}

export function usePostCustomerStatisticsGroupedMutation(
  options?: UseMutationOptions<
    CustomerStatisticsGroupedResponseView,
    Error,
    {
      data: CustomerStatisticsGroupedRequestView;
    },
    unknown
  >
): UseMutationResult<
  CustomerStatisticsGroupedResponseView,
  Error,
  {
    data: CustomerStatisticsGroupedRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: CustomerStatisticsGroupedRequestView }) => {
      const result = await api.postCustomerStatisticsGrouped(data);
      return result.data;
    },
    options
  );
}

export function usePostCustomerImportMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: CustomerBatchView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: CustomerBatchView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: CustomerBatchView }) => {
    const result = await api.postCustomerImport(data);
    return result.data;
  }, options);
}

export function usePostCustomerEventStatisticsGroupedMutation(
  options?: UseMutationOptions<
    CustomerEventStatisticsGroupedResponseView,
    Error,
    {
      data: CustomerEventStatisticsGroupedRequestView;
    },
    unknown
  >
): UseMutationResult<
  CustomerEventStatisticsGroupedResponseView,
  Error,
  {
    data: CustomerEventStatisticsGroupedRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: CustomerEventStatisticsGroupedRequestView }) => {
      const result = await api.postCustomerEventStatisticsGrouped(data);
      return result.data;
    },
    options
  );
}

export function usePostCustomerEventCampaignStatisticsTotalByCampaignIdMutation(
  options?: UseMutationOptions<
    CustomerEventStatisticsTotalResponseView,
    Error,
    {
      campaignId: string;

      data: CustomerEventStatisticsTotalRequestView;
    },
    unknown
  >
): UseMutationResult<
  CustomerEventStatisticsTotalResponseView,
  Error,
  {
    campaignId: string;

    data: CustomerEventStatisticsTotalRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      campaignId,
      data,
    }: {
      campaignId: string;
      data: CustomerEventStatisticsTotalRequestView;
    }) => {
      const result =
        await api.postCustomerEventCampaignStatisticsTotalByCampaignId(
          campaignId,
          data
        );
      return result.data;
    },
    options
  );
}

export function usePostCustomerEventCampaignStatisticsMostOpenByCampaignIdMutation(
  options?: UseMutationOptions<
    CustomerEventMostOpenStatisticsResponseView,
    Error,
    {
      campaignId: string;

      data: CustomerEventMostOpenStatisticsFilterView;

      query: { offset?: number; limit?: number };
    },
    unknown
  >
): UseMutationResult<
  CustomerEventMostOpenStatisticsResponseView,
  Error,
  {
    campaignId: string;

    data: CustomerEventMostOpenStatisticsFilterView;

    query: { offset?: number; limit?: number };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      campaignId,
      data,
      query,
    }: {
      campaignId: string;
      data: CustomerEventMostOpenStatisticsFilterView;
      query: { offset?: number; limit?: number };
    }) => {
      const result =
        await api.postCustomerEventCampaignStatisticsMostOpenByCampaignId(
          campaignId,
          data,
          query
        );
      return result.data;
    },
    options
  );
}

export function usePostCustomerEventCampaignStatisticsMostOpenExportByCampaignIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      campaignId: string;

      data: CustomerEventMostOpenStatisticsFilterView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    campaignId: string;

    data: CustomerEventMostOpenStatisticsFilterView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      campaignId,
      data,
    }: {
      campaignId: string;
      data: CustomerEventMostOpenStatisticsFilterView;
    }) => {
      const result =
        await api.postCustomerEventCampaignStatisticsMostOpenExportByCampaignId(
          campaignId,
          data
        );
      return result.data;
    },
    options
  );
}

export function usePostCustomerEventCampaignStatisticsMostClickByCampaignIdMutation(
  options?: UseMutationOptions<
    CustomerEventMostClickStatisticsResponseView,
    Error,
    {
      campaignId: string;

      data: CustomerEventMostClickStatisticsFilterView;

      query: { offset?: number; limit?: number };
    },
    unknown
  >
): UseMutationResult<
  CustomerEventMostClickStatisticsResponseView,
  Error,
  {
    campaignId: string;

    data: CustomerEventMostClickStatisticsFilterView;

    query: { offset?: number; limit?: number };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      campaignId,
      data,
      query,
    }: {
      campaignId: string;
      data: CustomerEventMostClickStatisticsFilterView;
      query: { offset?: number; limit?: number };
    }) => {
      const result =
        await api.postCustomerEventCampaignStatisticsMostClickByCampaignId(
          campaignId,
          data,
          query
        );
      return result.data;
    },
    options
  );
}

export function usePostCustomerEventCampaignStatisticsMostClickExportByCampaignIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      campaignId: string;

      data: CustomerEventMostClickStatisticsFilterView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    campaignId: string;

    data: CustomerEventMostClickStatisticsFilterView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      campaignId,
      data,
    }: {
      campaignId: string;
      data: CustomerEventMostClickStatisticsFilterView;
    }) => {
      const result =
        await api.postCustomerEventCampaignStatisticsMostClickExportByCampaignId(
          campaignId,
          data
        );
      return result.data;
    },
    options
  );
}

export function usePostCustomerEventCampaignStatisticsGroupedByCampaignIdMutation(
  options?: UseMutationOptions<
    CustomerEventStatisticsGroupedResponseView,
    Error,
    {
      campaignId: string;

      data: CustomerEventStatisticsGroupedRequestView;
    },
    unknown
  >
): UseMutationResult<
  CustomerEventStatisticsGroupedResponseView,
  Error,
  {
    campaignId: string;

    data: CustomerEventStatisticsGroupedRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      campaignId,
      data,
    }: {
      campaignId: string;
      data: CustomerEventStatisticsGroupedRequestView;
    }) => {
      const result =
        await api.postCustomerEventCampaignStatisticsGroupedByCampaignId(
          campaignId,
          data
        );
      return result.data;
    },
    options
  );
}

export function usePostCustomerEventCampaignStatisticsExportByCampaignIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      campaignId: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    campaignId: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ campaignId }: { campaignId: string }) => {
    const result =
      await api.postCustomerEventCampaignStatisticsExportByCampaignId(
        campaignId
      );
    return result.data;
  }, options);
}

export function usePostAccountSegmentCustomersByAccountIdAndSegmentIdMutation(
  options?: UseMutationOptions<
    SegmentIdentityView1,
    Error,
    {
      accountId: string;

      segmentId: string;

      data: CustomerBatchView;
    },
    unknown
  >
): UseMutationResult<
  SegmentIdentityView1,
  Error,
  {
    accountId: string;

    segmentId: string;

    data: CustomerBatchView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      accountId,
      segmentId,
      data,
    }: {
      accountId: string;

      segmentId: string;

      data: CustomerBatchView;
    }) => {
      const result =
        await api.postAccountSegmentCustomersByAccountIdAndSegmentId(
          accountId,
          segmentId,
          data
        );
      return result.data;
    },
    options
  );
}

export function usePostAccountSegmentImportByAccountIdMutation(
  options?: UseMutationOptions<
    SegmentIdentityView1,
    Error,
    {
      accountId: string;

      data: SegmentImportView;
    },
    unknown
  >
): UseMutationResult<
  SegmentIdentityView1,
  Error,
  {
    accountId: string;

    data: SegmentImportView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      accountId,
      data,
    }: {
      accountId: string;
      data: SegmentImportView;
    }) => {
      const result = await api.postAccountSegmentImportByAccountId(
        accountId,
        data
      );
      return result.data;
    },
    options
  );
}

export function useDeleteSegmentMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: SegmentMultipleDeleteView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: SegmentMultipleDeleteView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: SegmentMultipleDeleteView }) => {
    const result = await api.deleteSegment(data);
    return result.data;
  }, options);
}

export function useDeleteSuppressionMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: SuppressionMultipleDeleteView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: SuppressionMultipleDeleteView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: SuppressionMultipleDeleteView }) => {
      const result = await api.deleteSuppression(data);
      return result.data;
    },
    options
  );
}

export function useToggleSuppressionTypeMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      suppressionId: string;
      scope: "GLOBAL" | "LOCAL";
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    suppressionId: string;
    scope: "GLOBAL" | "LOCAL";
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      suppressionId,
      scope,
    }: {
      suppressionId: string;
      scope: "GLOBAL" | "LOCAL";
    }) => {
      const result = await api.putToggleSuppressionType(suppressionId, scope);
      return result.data;
    },
    options
  );
}

export function useDeleteSegmentCustomerBySegmentIdAndCustomerIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      segmentId: string;

      customerId: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    segmentId: string;

    customerId: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      segmentId,
      customerId,
    }: {
      segmentId: string;
      customerId: string;
    }) => {
      const result = await api.deleteSegmentCustomerBySegmentIdAndCustomerId(
        segmentId,
        customerId
      );
      return result.data;
    },
    options
  );
}

export function useDeleteCustomerMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: IdsView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: IdsView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: IdsView }) => {
    const result = await api.deleteCustomer(data);
    return result.data;
  }, options);
}

export function useDeleteSuppressionDetailsItemMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      suppressionId: string;
      data: IdsView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    suppressionId: string;
    data: IdsView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      suppressionId,
      data,
    }: {
      suppressionId: string;
      data: IdsView;
    }) => {
      const result = await api.deleteSuppressionDetailsItem(
        suppressionId,
        data
      );
      return result.data;
    },
    options
  );
}

export function useDeleteCustomerByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ id }: { id: string }) => {
    const result = await api.deleteCustomerById(id);
    return result.data;
  }, options);
}

export function usePutContentSubjectFilterMutation(
  options?: UseMutationOptions<
    PageSubjectLineView,
    Error,
    {
      data: SubjectLineFilterView;

      query: { page?: number; size?: number; sort?: string[] };
    },
    unknown
  >
): UseMutationResult<
  PageSubjectLineView,
  Error,
  {
    data: SubjectLineFilterView;

    query: { page?: number; size?: number; sort?: string[] };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      data,
      query,
    }: {
      data: SubjectLineFilterView;
      query: { page?: number; size?: number; sort?: string[] };
    }) => {
      const result = await api.putContentSubjectFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePutContentSubjectFavoriteByIdAndIsFavoriteMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;

      isFavorite: boolean;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;

    isFavorite: boolean;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, isFavorite }: { id: string; isFavorite: boolean }) => {
      const result = await api.putContentSubjectFavoriteByIdAndIsFavorite(
        id,
        isFavorite
      );
      return result.data;
    },
    options
  );
}

export function usePostContentSubjectGenerateMutation(
  options?: UseMutationOptions<
    SubjectGenerateResponseView,
    Error,
    {
      data: SubjectGenerateRequestView;
    },
    unknown
  >
): UseMutationResult<
  SubjectGenerateResponseView,
  Error,
  {
    data: SubjectGenerateRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: SubjectGenerateRequestView }) => {
    const result = await api.postContentSubjectGenerate(data);
    return result.data;
  }, options);
}

export function usePutFormByIdMutation(
  options?: UseMutationOptions<
    FormUpdateResponseView,
    Error,
    {
      id: string;

      data: FormUpdateRequestView;
    },
    unknown
  >
): UseMutationResult<
  FormUpdateResponseView,
  Error,
  {
    id: string;

    data: FormUpdateRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, data }: { id: string; data: FormUpdateRequestView }) => {
      const result = await api.putFormById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutFormStatusByIdAndFormStatusMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;

      formStatus: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;

    formStatus: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, formStatus }: { id: string; formStatus: string }) => {
      const result = await api.putFormStatusByIdAndFormStatus(id, formStatus);
      return result.data;
    },
    options
  );
}

export function usePutFormFilterMutation(
  options?: UseMutationOptions<
    PageFormInfoView,
    Error,
    {
      data: FormFilterView;

      query: { page?: number; size?: number; sort?: string[] };
    },
    unknown
  >
): UseMutationResult<
  PageFormInfoView,
  Error,
  {
    data: FormFilterView;

    query: { page?: number; size?: number; sort?: string[] };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      data,
      query,
    }: {
      data: FormFilterView;
      query: { page?: number; size?: number; sort?: string[] };
    }) => {
      const result = await api.putFormFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePutFormConfigMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: FormConfigView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: FormConfigView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: FormConfigView }) => {
    const result = await api.putFormConfig(data);
    return result.data;
  }, options);
}

export function usePutFormConfigContentByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;

      data: FormContentView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;

    data: FormContentView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, data }: { id: string; data: FormContentView }) => {
      const result = await api.putFormConfigContentById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutFormConfigAppearanceByIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;

      data: FormAppearanceView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;

    data: FormAppearanceView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, data }: { id: string; data: FormAppearanceView }) => {
      const result = await api.putFormConfigAppearanceById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutFormConfigAllowedDomainsByIdMutation(
  options?: UseMutationOptions<
    FormAllowedDomainsView,
    Error,
    {
      id: string;

      data: FormAllowedDomainsView;
    },
    unknown
  >
): UseMutationResult<
  FormAllowedDomainsView,
  Error,
  {
    id: string;

    data: FormAllowedDomainsView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, data }: { id: string; data: FormAllowedDomainsView }) => {
      const result = await api.putFormConfigAllowedDomainsById(id, data);
      return result.data;
    },
    options
  );
}

export function usePutFormCheckAssignedAudiencesMutation(
  options?: UseMutationOptions<
    FormCheckAssignedAudiencesResponseView,
    Error,
    {
      data: FormCheckAssignedAudiencesRequestView;
    },
    unknown
  >
): UseMutationResult<
  FormCheckAssignedAudiencesResponseView,
  Error,
  {
    data: FormCheckAssignedAudiencesRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: FormCheckAssignedAudiencesRequestView }) => {
      const result = await api.putFormCheckAssignedAudiences(data);
      return result.data;
    },
    options
  );
}

export function usePutFormTemplateFavoriteByIdAndIsFavoriteMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      id: string;

      isFavorite: boolean;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    id: string;

    isFavorite: boolean;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ id, isFavorite }: { id: string; isFavorite: boolean }) => {
      const result = await api.putFormTemplateFavoriteByIdAndIsFavorite(
        id,
        isFavorite
      );
      return result.data;
    },
    options
  );
}

export function usePutFormTemplateFilterMutation(
  options?: UseMutationOptions<
    PageFormTemplateInfoView,
    Error,
    {
      data: FormTemplateFilterView;

      query: { page?: number; size?: number; sort?: string[] };
    },
    unknown
  >
): UseMutationResult<
  PageFormTemplateInfoView,
  Error,
  {
    data: FormTemplateFilterView;

    query: { page?: number; size?: number; sort?: string[] };
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      data,
      query,
    }: {
      data: FormTemplateFilterView;
      query: { page?: number; size?: number; sort?: string[] };
    }) => {
      const result = await api.putFormTemplateFilter(data, query);
      return result.data;
    },
    options
  );
}

export function usePostFormMutation(
  options?: UseMutationOptions<
    FormIdentityView,
    Error,
    {
      data: FormView;
    },
    unknown
  >
): UseMutationResult<
  FormIdentityView,
  Error,
  {
    data: FormView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: FormView }) => {
    const result = await api.postForm(data);
    return result.data;
  }, options);
}

export function useDeleteFormMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: FormDeleteRequestView;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: FormDeleteRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: FormDeleteRequestView }) => {
    const result = await api.deleteForm(data);
    return result.data;
  }, options);
}

export function usePostFormCloneMutation(
  options?: UseMutationOptions<
    FormCloneResponseView,
    Error,
    {
      data: FormCloneRequestView;
    },
    unknown
  >
): UseMutationResult<
  FormCloneResponseView,
  Error,
  {
    data: FormCloneRequestView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: FormCloneRequestView }) => {
    const result = await api.postFormClone(data);
    return result.data;
  }, options);
}

export function usePostFormByTemplateMutation(
  options?: UseMutationOptions<
    FormIdentityView,
    Error,
    {
      data: FormWithTemplateView;
    },
    unknown
  >
): UseMutationResult<
  FormIdentityView,
  Error,
  {
    data: FormWithTemplateView;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: FormWithTemplateView }) => {
    const result = await api.postFormByTemplate(data);
    return result.data;
  }, options);
}

export function usePostFormProviderByAccountIdAndFormIdMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      accountId: string;

      formId: string;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    accountId: string;

    formId: string;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ accountId, formId }: { accountId: string; formId: string }) => {
      const result = await api.postFormProviderByAccountIdAndFormId(
        accountId,
        formId
      );
      return result.data;
    },
    options
  );
}

export function usePutAutomationEnabledByAutomationIdAndIsEnabledMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      automationId: string;

      isEnabled: boolean;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    automationId: string;

    isEnabled: boolean;
  },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({
      automationId,
      isEnabled,
    }: {
      automationId: string;

      isEnabled: boolean;
    }) => {
      const result = await api.putAutomationEnabledByAutomationIdAndIsEnabled(
        automationId,
        isEnabled
      );
      return result.data;
    },
    options
  );
}

export function useGetEmailAuthenticationStatusQuery(
  email: string,

  options?: UseQueryOptions<SenderDetailsAuthenticationView, Error>
): UseQueryResult<SenderDetailsAuthenticationView, Error> {
  const api = useApi();
  const key = ["GET", "/email-auth/validate", email];
  return useQuery(
    key,
    async () => {
      const result = await api.getEmailAuthenticationStatusByEmail(email);
      return result.data;
    },
    options
  );
}

export function useGetEntriTokenQuery(
  applicationId: string,
  options?: UseQueryOptions<EntriTokenView, Error>
): UseQueryResult<EntriTokenView, Error> {
  const api = useApi();
  const key = ["GET", "/entri/token", applicationId];
  return useQuery(
    key,
    async () => {
      const result = await api.getEntriToken(applicationId);
      return result.data;
    },
    options
  );
}

export function useGetCnameRecordsQuery(
  email: string,

  options?: UseQueryOptions<DnsRecord[], Error>
): UseQueryResult<DnsRecord[], Error> {
  const api = useApi();
  const key = ["GET", "/email-auth/dns-records", email];
  return useQuery(
    key,
    async () => {
      const result = await api.getCnameRecords(email);
      return result.data;
    },
    options
  );
}

export function useResolveAccountIssueMutation(
  options?: UseMutationOptions<void, Error, ResolveIssueView, unknown>
): UseMutationResult<void, Error, ResolveIssueView, unknown> {
  const api = useApi();
  return useMutation(async (data: ResolveIssueView) => {
    const result = await api.resolveAccountIssue(data);
    return result.data;
  }, options);
}

export function useSetupNewMemberPasswordMutation(
  options?: UseMutationOptions<
    void,
    Error,
    {
      data: SetupMemberPassword;
    },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  {
    data: SetupMemberPassword;
  },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ data }: { data: SetupMemberPassword }) => {
    const result = await api.createMemberPassword(data);
    return result.data;
  }, options);
}

export function usePutCampaignLevelMetricsAiInsightsQuery(
  data: CampaignFilterView,
  query: { page?: number; size?: number; sort?: string[] },
  options?: UseQueryOptions<{ insights: string }, Error>
): UseQueryResult<{ insights: string }, Error> {
  const api = useApi();
  const key = [
    "PUT",
    "/campaign-analytics/campaign-level-metrics/ai-insights",
    data,
  ];

  return useQuery(
    key,
    async () => {
      const result = await api.putCampaignLevelMetricsAiInsights(data, query);
      return result.data;
    },
    options
  );
}

export function useGetEmailContentCheckQuery(
  campaignId: string,
  options?: UseQueryOptions<EmailContentCheckResponse, Error>
): UseQueryResult<EmailContentCheckResponse, Error> {
  const api = useApi();
  const key = ["GET", `/campaign/${campaignId}/link-analysis`, campaignId];

  return useQuery(
    key,
    async () => {
      const result = await api.getEmailContentCheck(campaignId);
      return result.data;
    },
    options
  );
}

export function useGetUnvettedCheckQuery(
  campaignId: string,
  options?: UseQueryOptions<EmailUnvettedCheckResponse, Error>
): UseQueryResult<EmailUnvettedCheckResponse, Error> {
  const api = useApi();
  const key = [
    "GET",
    `/campaign/${campaignId}/unvetted-restriction`,
    campaignId,
  ];

  return useQuery(
    key,
    async () => {
      const result = await api.getEmailUnvettedCheck(campaignId);
      return result.data;
    },
    options
  );
}

export function usePostDomainStatisticsQuery(
  data: { activityId: string; accountId: string; domainName?: string },
  query: { page?: number; size?: number; sort?: string[] },
  options?: any
) {
  const api = useApi();
  const key = ["POST", "/customer-action/domain-statistics", data, query];
  return useQuery(
    key,
    async () => {
      const result = await api.postDomainStatistics(data, query);
      return result.data;
    },
    options
  );
}

export function usePutWorkflowsFindFilterQuery(
  data: WorkflowFilterView,

  query: { page?: number; size?: number; sort?: string[] },

  options?: UseQueryOptions<PageWorkflowInfoView, Error>
): UseQueryResult<PageWorkflowInfoView, Error> {
  const api = useApi();
  const key = ["PUT", "/workflow", data, query];
  return useQuery(
    key,
    async () => {
      const result = await api.putWorkflowFindFilter(data, query);
      return result.data;
    },
    options
  );
}

export function useCheckCustomSegmentExistsMutation(): UseMutationResult<
  { dataAvailable: boolean },
  Error,
  SegmentDataExistCheckView
> {
  const api = useApi();
  return useMutation(async (data: SegmentDataExistCheckView) => {
    const result = await api.putCheckCustomSegmentExists(data);
    return result.data;
  });
}

export function usePutAITrafficControlLogsQuery(
  data: AITrafficControlLogsFilter,
  page = 0,
  size = 5,
  sort = "createdAt,DESC",
  options?: UseQueryOptions<AITrafficControlLogsResponse, Error>
): UseQueryResult<AITrafficControlLogsResponse, Error> {
  const api = useApi();
  const key = [
    "PUT",
    "/ai-traffic-control/history/logs",
    data,
    page,
    size,
    sort,
  ];

  return useQuery(
    key,
    async () => {
      const result = await api.putAITrafficControlLogs(data, page, size, sort);
      return result.data;
    },
    options
  );
}

export function usePutAITrafficControlStatsQuery(
  data: AITrafficControlStatsFilter,
  options?: UseQueryOptions<AITrafficControlStatsResponse, Error>
): UseQueryResult<AITrafficControlStatsResponse, Error> {
  const api = useApi();
  const key = ["PUT", "/ai-traffic-control/history/stats", data];

  return useQuery(
    key,
    async () => {
      const result = await api.putAITrafficControlStats(data);
      return result.data;
    },
    options
  );
}

export function usePutAITrafficControlSegmentsQuery(
  data: AITrafficControlSegmentsFilter,
  options?: UseQueryOptions<AITrafficControlSegmentsResponse, Error>
): UseQueryResult<AITrafficControlSegmentsResponse, Error> {
  const api = useApi();
  const key = ["PUT", "/ai-traffic-control/segments", data];

  return useQuery(
    key,
    async () => {
      const result = await api.putAITrafficControlSegments(data);
      return result.data;
    },
    options
  );
}

export function usePutAITrafficControlSegmentProgressQuery(
  data: AITrafficControlSegmentProgressRequest,
  options?: UseQueryOptions<AITrafficControlSegmentProgressResponse, Error>
): UseQueryResult<AITrafficControlSegmentProgressResponse, Error> {
  const api = useApi();
  const key = ["PUT", "/ai-traffic-control/progress", data];

  return useQuery(
    key,
    async () => {
      const result = await api.putAITrafficControlProgress(data);
      return result.data;
    },
    options
  );
}

export function usePutAITrafficControlEngagerStatsQuery(
  data: AITrafficControlEngagerStatsFilter,
  options?: UseQueryOptions<AITrafficControlEngagerStatsResponse, Error>
): UseQueryResult<AITrafficControlEngagerStatsResponse, Error> {
  const api = useApi();
  const key = ["PUT", "/ai-traffic-control/history/engager/stats", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putAITrafficControlEngagerStats(data);
      return result.data;
    },
    options
  );
}

export function useGetSubAccountsQuery(
  options?: UseQueryOptions<SubAccountUsageResponseView, Error>
): UseQueryResult<SubAccountUsageResponseView, Error> {
  const api = useApi();
  const key = ["GET", "/account-subscription/master-sub-usages"];

  return useQuery(
    key,
    async () => {
      const result = await api.getSubAccounts();
      return result.data;
    },
    options
  );
}

export function usePutSegmentCleanupHistoryQuery(
  data: SegmentCleanupHistoryRequestView,
  options?: UseQueryOptions<SegmentCleanupHistoriesResponseView, Error>
): UseQueryResult<SegmentCleanupHistoriesResponseView, Error> {
  const api = useApi();
  const key = ["PUT", "/segment/cleanup/history", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putSegmentCleanupHistory(data);
      return result.data;
    },
    options
  );
}

export function usePutSegmentCleanupFileDownloadQuery(
  data: SegmentCleanupFileDownloadRequestView,
  options?: UseQueryOptions<CleanedFileUrlView, Error>
): UseQueryResult<CleanedFileUrlView, Error> {
  const api = useApi();
  const key = [
    "PUT",
    `/segment/cleanup/file/${data.cleanedHistoryFileId}/download`,
    data,
  ];
  return useQuery(
    key,
    async () => {
      const result = await api.putSegmentCleanupFileDownload(data);
      return result.data;
    },
    options
  );
}

export function usePostProductCalculateCostMutation(
  options?: UseMutationOptions<
    ProductCalculateCostResponseView,
    Error,
    ProductCalculateCostRequestView
  >
): UseMutationResult<
  ProductCalculateCostResponseView,
  Error,
  ProductCalculateCostRequestView
> {
  const api = useApi();
  return useMutation(async (data: ProductCalculateCostRequestView) => {
    const result = await api.postProductCalculateCost(data);
    return result.data;
  }, options);
}

export function usePostProductPurchaseByCardIdMutation(
  options?: UseMutationOptions<
    ProductPurchaseResponseView,
    Error,
    { cardId: string; data: ProductPurchaseRequestView }
  >
): UseMutationResult<
  ProductPurchaseResponseView,
  Error,
  { cardId: string; data: ProductPurchaseRequestView }
> {
  const api = useApi();
  return useMutation(async ({ cardId, data }) => {
    const result = await api.postProductPurchaseByCardId(cardId, data);
    return result.data;
  }, options);
}

export function useGetProductTiersByProductIdQuery(
  productId: string,
  options?: UseQueryOptions<ProductTierView[], Error>
): UseQueryResult<ProductTierView[], Error> {
  const api = useApi();
  const key = ["GET", `/product/${productId}/tiers`, productId];
  return useQuery(
    key,
    async () => {
      const result = await api.getProductTiersByProductId(productId);
      return result.data;
    },
    options
  );
}

export function useGetAccountDeliverabilityQuery(
  options?: UseQueryOptions<DeliverabilitySettingsView, Error>
): UseQueryResult<DeliverabilitySettingsView, Error> {
  const api = useApi();
  const key = ["GET", "/account/deliverability"];
  return useQuery(
    key,
    async () => {
      const result = await api.getAccountDeliverability();
      return result.data;
    },
    options
  );
}

export function usePutAccountDeliverabilityMutation(
  options?: UseMutationOptions<
    void,
    Error,
    { data: Partial<DeliverabilitySettingsView> },
    unknown
  >
): UseMutationResult<
  void,
  Error,
  { data: Partial<DeliverabilitySettingsView> },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: Partial<DeliverabilitySettingsView> }) => {
      const result = await api.putAccountDeliverability(data);
      return result.data;
    },
    options
  );
}

export function useGetGlobalActiveEngagerSegmentQuery(
  accountId: string,
  options?: UseQueryOptions<GlobalActiveEngagerSegmentView, Error>
): UseQueryResult<GlobalActiveEngagerSegmentView, Error> {
  const api = useApi();
  const key = ["GET", `/global-active-engager/${accountId}/segment`];
  return useQuery(
    key,
    async () => {
      const result = await api.getGlobalActiveEngagerSegment(accountId);
      return result.data;
    },
    { enabled: !!accountId, ...options }
  );
}

export function useGetGlobalActiveEngagerSettingsQuery(
  accountId: string,
  options?: UseQueryOptions<GlobalActiveEngagerSettingsView, Error>
): UseQueryResult<GlobalActiveEngagerSettingsView, Error> {
  const api = useApi();
  const key = ["GET", `/global-active-engager/${accountId}/settings`];
  return useQuery(
    key,
    async () => {
      const result = await api.getGlobalActiveEngagerSettings(accountId);
      return result.data;
    },
    { enabled: !!accountId, ...options }
  );
}

export function usePutGlobalActiveEngagerSettingsMutation(
  accountId: string,
  options?: UseMutationOptions<
    void,
    Error,
    GlobalActiveEngagerSettingsView,
    unknown
  >
): UseMutationResult<void, Error, GlobalActiveEngagerSettingsView, unknown> {
  const api = useApi();
  return useMutation(async (data: GlobalActiveEngagerSettingsView) => {
    const result = await api.putGlobalActiveEngagerSettings(accountId, data);
    return result.data;
  }, options);
}

export function usePutPreSignedUrlGenerateMutation(
  options?: UseMutationOptions<
    PreSignedUrlGenerateResponseView,
    Error,
    { data: PreSignedUrlGenerateRequestView },
    unknown
  >
): UseMutationResult<
  PreSignedUrlGenerateResponseView,
  Error,
  { data: PreSignedUrlGenerateRequestView },
  unknown
> {
  const api = useApi();
  return useMutation(
    async ({ data }: { data: PreSignedUrlGenerateRequestView }) => {
      const result = await api.putPreSignedUrlGenerate(data);
      return result.data;
    },
    options
  );
}

export function useGetCreditBalanceQuery(
  productId: string,
  options?: UseQueryOptions<CreditBalanceView, Error>
): UseQueryResult<CreditBalanceView, Error> {
  const api = useApi();
  const key = ["GET", `/credits/product/${productId}/balance`, productId];
  return useQuery(
    key,
    async () => {
      const result = await api.getCreditBalance(productId);
      return result.data;
    },
    options
  );
}

export function usePostCreditPurchaseByPaymentMethodIdMutation(
  options?: UseMutationOptions<
    CreditPurchaseResponseView,
    Error,
    { paymentMethodId: string; data: CreditPurchaseRequestView }
  >
): UseMutationResult<
  CreditPurchaseResponseView,
  Error,
  { paymentMethodId: string; data: CreditPurchaseRequestView }
> {
  const api = useApi();
  return useMutation(async ({ paymentMethodId, data }) => {
    const result = await api.postCreditPurchaseByPaymentMethodId(
      paymentMethodId,
      data
    );
    return result.data;
  }, options);
}

export function usePostCreditsUseMutation(
  options?: UseMutationOptions<
    CreditsUseResponseView,
    Error,
    CreditsUseRequestView
  >
): UseMutationResult<CreditsUseResponseView, Error, CreditsUseRequestView> {
  const api = useApi();
  return useMutation(async (data: CreditsUseRequestView) => {
    const result = await api.postCreditsUse(data);
    return result.data;
  }, options);
}

export function usePostCreditsCalculateMutation(
  options?: UseMutationOptions<
    CreditsCalculateResponseView,
    Error,
    CreditsCalculateRequestView
  >
): UseMutationResult<
  CreditsCalculateResponseView,
  Error,
  CreditsCalculateRequestView
> {
  const api = useApi();
  return useMutation(async (data: CreditsCalculateRequestView) => {
    const result = await api.postCreditsCalculate(data);
    return result.data;
  }, options);
}

export function useGetProductUsageHistoryQuery(
  productId: string,
  params: { page?: number; size?: number } = {},
  options?: UseQueryOptions<ProductUsageHistoryView, Error>
): UseQueryResult<ProductUsageHistoryView, Error> {
  const api = useApi();
  const key = ["GET", `/product/${productId}/usage-history`, productId, params];
  return useQuery(
    key,
    async () => {
      const result = await api.getProductUsageHistory(productId, params);
      return result.data;
    },
    options
  );
}

export function useGetProductPurchaseHistoryQuery(
  productId: string,
  params: { page?: number; size?: number } = {},
  options?: UseQueryOptions<ProductPurchaseHistoryView, Error>
): UseQueryResult<ProductPurchaseHistoryView, Error> {
  const api = useApi();
  const key = [
    "GET",
    `/product/${productId}/purchase-history`,
    productId,
    params,
  ];
  return useQuery(
    key,
    async () => {
      const result = await api.getProductPurchaseHistory(productId, params);
      return result.data;
    },
    options
  );
}

export function useGetAllBillingProductsQuery(
  options?: UseQueryOptions<ProductView[], Error>
): UseQueryResult<ProductView[], Error> {
  const api = useApi();
  const key = ["GET", "/product"];
  return useQuery(
    key,
    async () => {
      const result = await api.getAllBillingProducts();
      return result.data;
    },
    options
  );
}

export function useGetRetentionIntegrationQuery(
  options?: UseQueryOptions<RetentionIntegrationView, Error>
): UseQueryResult<RetentionIntegrationView, Error> {
  const api = useApi();
  const key = ["GET", "/product/retention/integration"];
  return useQuery(
    key,
    async () => {
      const result = await api.getRetentionIntegration();
      return result.data;
    },
    { staleTime: 5 * 60 * 1000, ...options }
  );
}

export function usePostRetentionActivateMutation(
  options?: UseMutationOptions<
    RetentionIntegrationView,
    Error,
    { segmentId: string; reactivationSegmentId?: string; website?: string }
  >
): UseMutationResult<
  RetentionIntegrationView,
  Error,
  { segmentId: string; reactivationSegmentId?: string; website?: string }
> {
  const api = useApi();
  return useMutation(async ({ segmentId, reactivationSegmentId, website }) => {
    const result = await api.postRetentionActivate({
      segmentId,
      reactivationSegmentId,
      website,
    });
    return result.data;
  }, options);
}

export function useGetAutoTopUpConfigQuery(
  productId: string,
  options?: UseQueryOptions<AutoTopUpConfigView, Error>
): UseQueryResult<AutoTopUpConfigView, Error> {
  const api = useApi();
  const key = ["GET", `/credits/product/${productId}/auto-top-up`];
  return useQuery(
    key,
    async () => {
      const result = await api.getAutoTopUpConfig(productId);
      return result.data;
    },
    { staleTime: 5 * 60 * 1000, ...options }
  );
}

export function usePutAutoTopUpConfigMutation(
  options?: UseMutationOptions<
    AutoTopUpConfigView,
    Error,
    { productId: string } & AutoTopUpConfigUpdateView
  >
): UseMutationResult<
  AutoTopUpConfigView,
  Error,
  { productId: string } & AutoTopUpConfigUpdateView
> {
  const api = useApi();
  return useMutation(async ({ productId, ...data }) => {
    const result = await api.putAutoTopUpConfig(productId, data);
    return result.data;
  }, options);
}

export function usePostFormImageMutation(
  options?: UseMutationOptions<
    FormImageUploadResponseView,
    Error,
    { image: File },
    unknown
  >
): UseMutationResult<
  FormImageUploadResponseView,
  Error,
  { image: File },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ image }: { image: File }) => {
    const result = await api.postFormImage({ image });
    return result.data;
  }, options);
}

export function usePostNewSubscriberEngagementMutation(
  options?: UseMutationOptions<
    SubscriberEngagementItemView[],
    Error,
    SubscriberEngagementRequestView
  >
): UseMutationResult<
  SubscriberEngagementItemView[],
  Error,
  SubscriberEngagementRequestView
> {
  const api = useApi();
  return useMutation(async (_data) => {
    const result = await api.postNewSubscriberEngagement(_data);
    return result.data;
  }, options);
}

export function usePostIspNewSubscriberEngagementMutation(
  options?: UseMutationOptions<
    IspEngagementItemView[],
    Error,
    IspEngagementRequestView
  >
): UseMutationResult<IspEngagementItemView[], Error, IspEngagementRequestView> {
  const api = useApi();
  return useMutation(async (_data) => {
    const result = await api.postIspNewSubscriberEngagement(_data);
    return result.data.targetedStats;
  }, options);
}

export function useGetCustomAttributesQuery(
  options?: UseQueryOptions<CustomAttributesResponseView, Error>
): UseQueryResult<CustomAttributesResponseView, Error> {
  const api = useApi();
  const key = ["GET", "/custom-attributes/get"];
  return useQuery(
    key,
    async () => {
      const result = await api.getCustomAttributes();
      return result.data;
    },
    options
  );
}

export function useCreateCustomAttributeMutation(
  options?: UseMutationOptions<
    CustomAttributeDefinitionView,
    Error,
    CreateCustomAttributeRequestView
  >
): UseMutationResult<
  CustomAttributeDefinitionView,
  Error,
  CreateCustomAttributeRequestView
> {
  const api = useApi();
  return useMutation(async (data) => {
    const result = await api.createCustomAttribute(data);
    return result.data;
  }, options);
}

export function useDeleteCustomAttributeMutation(
  options?: UseMutationOptions<void, Error, DeleteCustomAttributeRequestView>
): UseMutationResult<void, Error, DeleteCustomAttributeRequestView> {
  const api = useApi();
  return useMutation(async (data) => {
    const result = await api.deleteCustomAttribute(data);
    return result.data;
  }, options);
}

export function useGetCustomAttributeMergeTagsQuery(
  options?: UseQueryOptions<CustomAttributeMergeTagsView, Error>
): UseQueryResult<CustomAttributeMergeTagsView, Error> {
  const api = useApi();
  const key = ["GET", "/custom-attributes/merge-tag"];
  return useQuery(
    key,
    async () => {
      const result = await api.getCustomAttributeMergeTags();
      return result.data;
    },
    options
  );
}

export function usePutWorkflowEmailTemplatePreviewGetQuery(
  data: WorkflowTemplatePreviewFilterView,
  options?: UseQueryOptions<WorkflowTemplatePreviewResponseView, Error>
): UseQueryResult<WorkflowTemplatePreviewResponseView, Error> {
  const api = useApi();
  const key = ["PUT", "/workflow-email-template/preview", data];
  return useQuery(
    key,
    async () => {
      const result = await api.putWorkflowEmailTemplatePreview(data);
      return result.data;
    },
    options
  );
}

export function usePostRelayStatsQuery(
  data: RelayStatsFilter,
  query: { page: number; size: number; sort: string },
  options?: UseQueryOptions<RelayStatsResponse, Error>
): UseQueryResult<RelayStatsResponse, Error> {
  const api = useApi();
  const key = ["POST", "/dashboard/relay-stats", data, query];

  return useQuery(
    key,
    async () => {
      const result = await api.postRelayStats(data, query);
      return result.data;
    },
    options
  );
}

export function usePutSuppressionFindSearchMutation(
  options?: UseMutationOptions<
    SuppressionSearchResponseView,
    Error,
    { email: string },
    unknown
  >
): UseMutationResult<
  SuppressionSearchResponseView,
  Error,
  { email: string },
  unknown
> {
  const api = useApi();
  return useMutation(async ({ email }: { email: string }) => {
    const result = await api.putSuppressionFindSearch({ email });
    return result.data;
  }, options);
}

export function usePostEngagementScoringAnalyticsQuery(
  data: EngagementScoringAnalyticsRequest,
  options?: UseQueryOptions<EngagementScoringAnalyticsResponse, Error>
): UseQueryResult<EngagementScoringAnalyticsResponse, Error> {
  const api = useApi();
  const key = ["POST", "/engagement-scoring/analytics", data];
  return useQuery(
    key,
    async () => {
      const result = await api.postEngagementScoringAnalytics(data);
      return result.data;
    },
    options
  );
}

export function useGetRelayManagementQuery(
  query: { page: number; size: number; sort?: string; name?: string },
  options?: UseQueryOptions<RelayManagementPageResponse, Error>
): UseQueryResult<RelayManagementPageResponse, Error> {
  const api = useApi();
  const key = ["GET", "/relay-management", query];
  return useQuery(
    key,
    async () => {
      const result = await api.getRelayManagement(query);
      return result.data;
    },
    options
  );
}

export function useGetApiKeysQuery(
  options?: UseQueryOptions<ApiKeyView[], Error>
): UseQueryResult<ApiKeyView[], Error> {
  const api = useApi();
  const key = ["GET", "/api-keys"];
  return useQuery(
    key,
    async () => {
      const result = await api.getApiKeys();
      return result.data;
    },
    options
  );
}

export function usePostApiKeysMutation(
  options?: UseMutationOptions<ApiKeyView, Error, ApiKeyCreateRequestView>
): UseMutationResult<ApiKeyView, Error, ApiKeyCreateRequestView> {
  const api = useApi();
  return useMutation(async (data: ApiKeyCreateRequestView) => {
    const result = await api.postApiKeys(data);
    return result.data;
  }, options);
}

export function usePutApiKeysMutation(
  options?: UseMutationOptions<ApiKeyView, Error, ApiKeyUpdateRequestView>
): UseMutationResult<ApiKeyView, Error, ApiKeyUpdateRequestView> {
  const api = useApi();
  return useMutation(async (data: ApiKeyUpdateRequestView) => {
    const result = await api.putApiKeys(data);
    return result.data;
  }, options);
}

export function useDeleteApiKeysByIdMutation(
  options?: UseMutationOptions<void, Error, number>
): UseMutationResult<void, Error, number> {
  const api = useApi();
  return useMutation(async (id: number) => {
    await api.deleteApiKeysById(id);
  }, options);
}

export function useGetCampaignFeedbackSummaryQuery(
  query: { dateFrom?: string; dateTo?: string },

  options?: UseQueryOptions<FeedbackSummaryResponseView, Error>
): UseQueryResult<FeedbackSummaryResponseView, Error> {
  const api = useApi();
  const key = ["GET", "reportservice/campaign/feedback/summary", query];
  return useQuery(
    key,
    async () => {
      const result = await api.getCampaignFeedbackSummary(query);
      return result.data;
    },
    options
  );
}

export function useGetCampaignFeedbackRankingsQuery(
  query: CampaignFeedbackRankingQuery,

  options?: UseQueryOptions<CampaignFeedbackRankingResponseView, Error>
): UseQueryResult<CampaignFeedbackRankingResponseView, Error> {
  const api = useApi();
  const key = ["GET", "reportservice/campaign/feedback/rankings", query];
  return useQuery(
    key,
    async () => {
      const result = await api.getCampaignFeedbackRankings(query);
      return result.data;
    },
    options
  );
}

export function useGetCampaignFeedbackSummaryByIdQuery(
  id: string,

  options?: UseQueryOptions<FeedbackSummaryResponseView, Error>
): UseQueryResult<FeedbackSummaryResponseView, Error> {
  const api = useApi();
  const key = ["GET", `reportservice/campaign/feedback/${id}/summary`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.getCampaignFeedbackSummaryById(id);
      return result.data;
    },
    options
  );
}

export function useGetCampaignFeedbackDistributionByIdQuery(
  id: string,

  options?: UseQueryOptions<FeedbackDistributionResponseView, Error>
): UseQueryResult<FeedbackDistributionResponseView, Error> {
  const api = useApi();
  const key = ["GET", `reportservice/campaign/feedback/${id}/distribution`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.getCampaignFeedbackDistributionById(id);
      return result.data;
    },
    options
  );
}

export function useGetCampaignFeedbackTimeSeriesByIdQuery(
  id: string,

  options?: UseQueryOptions<FeedbackTimeSeriesResponseView, Error>
): UseQueryResult<FeedbackTimeSeriesResponseView, Error> {
  const api = useApi();
  const key = ["GET", `reportservice/campaign/feedback/${id}/time-series`, id];
  return useQuery(
    key,
    async () => {
      const result = await api.getCampaignFeedbackTimeSeriesById(id);
      return result.data;
    },
    options
  );
}
